import {Link, useHistory} from 'react-router-dom';
import {useEffect, useState} from 'react';
import Api from '../api/api';
import Loader from '../shared/loader';
import Enums from '../../utilities/enum';
import StringHelpers from '../../utilities/stringHelpers';
import arrayUtilities from '../../utilities/arrayUtilities';
import formUtilities from '../../utilities/formUtilities';
import roleUtilities from '../../utilities/roleUtilities';
import {ConfigurationUpdate} from '../shared/configurationUpdate';
import Pagination from '../shared/pagination';
import {ClientSiteTabbed} from '../allow-list/clientSiteTabbed';
import {ColumnSortTrigger} from '../shared/columnSortTrigger';
import {ErrorModal} from '../../utilities/errorModal';
import {FormSiteGeneralDetails} from './addEditSite/formSiteGeneralDetails';
import {DisplayGeneralDetails} from './addEditSite/displayGeneralDetails';
import {FormSitePaymentProviders} from './addEditSite/formSitePaymentProviders';
import {FormSiteCodes} from './addEditSite/formSiteCodes';
import {FormSiteSpaces} from './addEditSite/formSiteSpaces';
import {
    endOfDay,
    isDateTimeElapsed,
    isToDateAfterFromDate,
    startOfDay,
    toDateTimeString,
    toInputFieldDateTimeString,
    toInputFieldDateString,
    dateRange,
    toDateString,
    toTimeString
} from '../../utilities/dateUtilities';
import {TimeRangeSlider} from '../shared/timeRangeSlider';
import {renderValidity} from '../../utilities/allowListUtilities';
import {SiteDisallowListAccordion} from './siteDisallowListAccordion';
import {AttachmentsDisplay} from '../shared/attachmentsDisplay';
import {Modal} from 'react-bootstrap';
import {AppliedFilterDisplay} from '../shared/appliedFilterDisplay';
import {AllowListFiltersModal} from '../shared/allowListFiltersModal';
import {SearchBarWithDebounce} from '../shared/searchBarWithDebounce';
import {FiltersModalTrigger} from '../shared/filtersModalTrigger';
import {CamerasFiltersModal} from './camerasFiltersModal';
import { PayDisplayMachinesFiltersModal } from './payDisplayMachinesFiltersModal';
import {SiteAnprSettingsTable} from './siteAnprSettingsTable';
import { DateTimePickerWithCustomDisplay } from '../shared/dateTimePickerCustomDisplay';
import { MinutesInputWithUnit } from '../shared/minutesInputWithUnit';

function Site(props) {
    const isThirdPartyUser = roleUtilities.isThirdPartyProcessor(props.user, props.organisationId) || roleUtilities.isThirdPartyManager(props.user, props.organisationId)
    const [siteId, setSiteId] = useState(props.match.params.siteId);
    const [clientId, setClientId] = useState(props.match.params.clientId);
    const [site, setSite] = useState(null);
    const [clientUrl, setClientUrl] = useState("");
    const [cameraUrl, setCameraUrl] = useState("");
    const [contraventionUrl, setContraventionUrl] = useState("");
    const [payDisplayUrl, setPayDisplayUrl] = useState("");

    const [detailsInEdit, setDetailsInEdit] = useState(false);
    const [camerasInEdit, setCamerasInEdit] = useState(false);
    const [contraventionsInEdit, setContraventionsInEdit] = useState(false);
    const [allowListInEdit, setAllowListInEdit] = useState(false);
    const [canSave, setCanSave] = useState(false);
    const [allTags, setAllTags] = useState(null);
    const [tagUpdateError, setTagUpdateError] = useState(false)
    const [selectedTags, setSelectedTags] = useState(null);
    const [allContraventions, setAllContraventions] = useState(null);
    const [siteContraventions, setSiteContraventions] = useState(null);
    const [attachments, setAttachments] = useState(null);
    const [attachmentsDefaultTab, setAttachmentsDefaultTab] = useState("images");
    const [attachmentUploads, setAttachmentUploads] = useState([]);
    const [attachmentValidFrom, setAttachmentValidFrom] = useState(null)
    const [attachmentValidTo, setAttachmentValidTo] = useState(null)
    const [isSavingAttachments, setIsSavingAttachments] = useState(false)
    const [attachmentUploadProgress, setAttachmentUploadProgress] = useState(1);
    const [attachmentUploadComplete, setAttachmentUploadComplete] = useState(false);
    const [attachmentUploadError, setAttachmentUploadError] = useState(false);
    const [deleteAttachmentId, setDeleteAttachmentId] = useState(null);
    const [editableAttachment, setEditableAttachment] = useState(null);
    const [attachmentUpdateError, setAttachmentUpdateError] = useState(null);

    //details
    const [name, setName] = useState("");
    const [siteCode, setSiteCode] = useState("");
    const [parkonomySiteCode, setParkonomySiteCode] = useState("");
    const [parkBunnyLocationId, setParkBunnyLocationId] = useState("");
    const [justParkLocationId, setJustParkLocationId] = useState("");
    const [tap2ParkLocationId, setTap2ParkLocationId] = useState("");
    const [payByPhoneLocationId, setPayByPhoneLocationId] = useState("");
    const [ringGoZone, setRingGoZone] = useState("");
    const [ipsLocationId, setIpsLocationId] = useState("");
    const [conviousLocationId, setConviousLocationId] = useState("");
    const [lookingForCarParkLocationId, setLookingForCarParkLocationId] = useState("");
    const [newParkLocationId, setNewParkLocationId] = useState("");
    const [parksoLocationId, setParksoLocationId] = useState("");
    const [myCarPassLocationId, setMyCarPassLocationId] = useState("");
    const [permitPrefix, setPermitPrefix] = useState("");
    const [iasIpcCode, setIasIpcCode] = useState("");
    const [status, setStatus] = useState(false);
    const [allowCancellationOfBreaches, setAllowCancellationOfBreaches] = useState(false)
    const [enableAutoAssignUser, setEnableAutoAssignUser] = useState(false)
    const [autoAssignedUser, setAutoAssignUser] = useState("")
    const [vehicleAnalyticsEnabled, setVehicleAnalyticsEnabled] = useState(false)
    const [preventDuplicateBreaches, setPreventDuplicateBreaches] = useState(false)
    const [maximumCancellationsPerMonth, setMaximumCancellationsPerMonth] = useState("")
    const [contractExpiry, setContractExpiry] = useState("");
    const [jurisdiction, setJurisdiction] = useState("0")
    const [addressLine1, setAddressLine1] = useState("");
    const [addressLine2, setAddressLine2] = useState("");
    const [addressLine3, setAddressLine3] = useState("");
    const [postCode, setPostCode] = useState("");
    const [townOrCity, setTownOrCity] = useState("");
    const [iasEnabled, setIasEnabled] = useState(false);
    const [bpaEnabled, setBpaEnabled] = useState(false);
    const [bpaCode, setBpaCode] = useState("");
    const [pofaEnabled, setPofaEnabled] = useState(false);
    const [debtCollectionProviderId, setDebtCollectionProviderId] = useState(null)

    const [regionId, setRegionId] = useState(null)
    //cameras
    const [anprEnabled, setAnprEnabled] = useState(false);
    const [maxAllowedParkingDuration, setMaxAllowedParkingDuration] = useState(0);
    const [considerationPeriod, setConsiderationPeriod] = useState(0);
    const [allowListEntryGrace, setAllowListEntryGrace] = useState(0);
    const [allowListExitGrace, setAllowListExitGrace] = useState(0);
    const [allowListDurationGrace, setAllowListDurationGrace] = useState(0);
    const [contraventionsForOverStayEnabled, setContraventionsForOverStayEnabled] = useState(false);
    const [contraventionsForOverStay, setContraventionsForOverStay] = useState(null);
    const [contraventionsForNotOnAllowListEnabled, setContraventionsForNotOnAllowListEnabled] = useState(false);
    const [contraventionsForNotOnAllowList, setContraventionsForNotOnAllowList] = useState(null);
    const [contraventionsForShortReturnEnabled, setContraventionsForShortReturnEnabled] = useState(false);
    const [contraventionsForShortReturn, setContraventionsForShortReturn] = useState(null);
    const [parkingSessionLimit, setParkingSessionLimit] = useState(0);
    const [noReturnWithin, setNoReturnWithin] = useState(0);

    //spaces
    const [payAndDisplaySpaces, setPayAndDisplaySpaces] = useState(0);
    const [preAllocatedSpaces, setPreAllocatedSpaces] = useState(0);
    const [disabledSpaces, setDisabledSpaces] = useState(0);
    const [permitSpaces, setPermitSpaces] = useState(0);
    const [otherSpaces, setOtherSpaces] = useState(0);

    //camera list
    const [cameras, setCameras] = useState(null);

    //pd machines list
    const [pdMachines, setPdMachines] = useState(null);

    //allow list 
    const [allowListData, setAllowListData] = useState(null);
    const [search, setSearch] = useState(null);
    const [filterEnd, setFilterEnd] = useState(null);
    const [filterStart, setFilterStart] = useState(null);
    const [pageNumber, setPageNumber] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [filterPeriodType, setFilterPeriodType] = useState("0");
    const [currentSortBy, setCurrentSortBy] = useState(StringHelpers.sortPreference(`${props.user.id}-allowListSortPreference`).sortBy);
    const [createdByUserId, setCreatedByUserId] = useState(null)
    const [createdBySource, setCreatedBySource] = useState(null)
    const [createdByOptions, setCreatedByOptions] = useState([])
    const [showAllowListFiltersModal, setShowAllowListFiltersModal] = useState(false);
    const [showAllowListFilterPills, setShowAllowListFilterPills] = useState(false);
    const [allowListAppliedFilters, setAllowListAppliedFilters] = useState(null);

    //cameras
    const [camerasSearch, setCamerasSearch] = useState(null);
    const [cameraFilterStatus, setCameraFilterStatus] = useState(null);
    const [showCamerasFiltersModal, setShowCamerasFiltersModal] = useState(false);
    const [showCamerasFilterPills, setShowCamerasFilterPills] = useState(false);
    const [camerasAppliedFilters, setCamerasAppliedFilters] = useState(null);

    //pd machines
    const [payDisplaySearch, setPayDisplaySearch] = useState(null);
    const [payDisplayFilterStatus, setPayDisplayFilterStatus] = useState(null);
    const [showPayDisplayFiltersModal, setShowPayDisplayFiltersModal] = useState(false);
    const [showPayDisplayFilterPills, setShowPayDisplayFilterPills] = useState(false);
    const [payDisplayAppliedFilters, setPayDisplayAppliedFilters] = useState(null);

    //new allow list item
    const [vrm, setVrm] = useState("");
    const [vehicleMake, setVehicleMake] = useState("");
    const [vehicleModel, setVehicleModel] = useState("");
    const [colour, setColour] = useState("");
    const [reference, setReference] = useState("");    
    const [driverName, setDriverName] = useState("");
    const [driverMobileNumber, setDriverMobileNumber] = useState("");
    const [blueBadgeNumber, setBlueBadgeNumber] = useState("");
    const [blueBadgeExpiryDate, setBlueBadgeExpiryDate] = useState("");
    const [driverEmailAddress, setDriverEmailAddress] = useState("");
    const [startDate, setStartDate] = useState("");
    const [typeDateTime, setTypeDateTime] = useState("0")    
    const { firstDate, lastDate } = dateRange("currentDay")
    const [endDate, setEndDate] = useState("");
    const [reason, setReason] = useState("");
    const [anprCameraId, setAnprCameraId] = useState(null);
    const [roi, setRoi] = useState(null);
    const [allowListItemSiteGroup, setAllowListItemSiteGroup] = useState(null);
    const [clients, setClients] = useState(null);
    const [allowListClientId, setAllowListClientId] = useState("");
    const [tabActiveKey, setTabActiveKey] = useState("site");
    const [allowListError, setAllowListError] = useState("");
    const [validOnlyOnSpecificDays, setValidOnlyOnSpecificDays] = useState(false)
    const [isValidMonday, setIsValidMonday] = useState(false)
    const [isValidTuesday, setIsValidTuesday] = useState(false)
    const [isValidWednesday, setIsValidWednesday] = useState(false)
    const [isValidThursday, setIsValidThursday] = useState(false)
    const [isValidFriday, setIsValidFriday] = useState(false)
    const [isValidSaturday, setIsValidSaturday] = useState(false)
    const [isValidSunday, setIsValidSunday] = useState(false)
    const [enabledFromTime, setEnabledFromTime] = useState("00:00:00")
    const [enabledToTime, setEnabledToTime] = useState("23:59:00")
    const [validOnlyAtSpecificTimes, setValidOnlyAtSpecificTimes] = useState(false)
    const [maxStayMinutes, setMaxStayMinutes] = useState(null);
    const [noReturnWithinMinutes, setNoReturnWithinMinutes] = useState(null);

    //notes
    const [notes, setNotes] = useState(null);
    const [note, setNote] = useState("");

    //attachment
    const [attachmentFileIds, setAttachmentFileIds] = useState([]);
    const [canAddAllowList, setCanAddAllowList] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    // overnight stay contraventions
    const [overnightStaySettingsEnabled, setOvernightStaySettingsEnabled] = useState(false);
    const [overnightStayContraventionId, setOvernightStayContraventionId] = useState(null);
    const [overnightStayGraceMinutes, setOvernightStayGraceMinutes] = useState(0);
    const [overnightStayStartTime, setOvernightStayStartTime] = useState(60);
    const [overnightStayEndTime, setOvernightStayEndTime] = useState(300);

    //pay and display
    const [isPayDisplay, setIsPayDisplay] = useState(false);
    const [contraventionsForFailToPay, setContraventionsForFailToPay] = useState(null);
    const [contraventionsForOverStayPaymentPeriod, setContraventionsForOverStayPaymentPeriod] = useState(null);
    const [freeParkingMinutes, setFreeParkingMinutes] = useState(0);

    const [variableAnprRanges, setVariableAnprRanges] = useState(null)
    // kiosks
    const [kiosks, setKiosks] = useState(null);

    // site group
    const [siteGroups, setSiteGroups] = useState(null);
    const [siteGroupId, setSiteGroupId] = useState(null);

    const [loadingVehicleLookup, setLoadingVehicleLookup] = useState(false)
    const [vehicleLookupError, setVehicleLookupError] = useState(null)
    const [successfulLookupVrm, setSuccessfulLookupVrm] = useState(null)
    const [showSuspensionWarning, setShowSuspensionWarning] = useState(false);

    const attachmentsLayoutKey = `${props.user.id}-siteAttachmentLayoutPreference`;
    const [attachmentsLayout, setAttachmentsLayout] = useState(localStorage.getItem(attachmentsLayoutKey) ?? "grid")
    const [deleteKiosk, setDeleteKiosk] = useState(null)
    const history = useHistory();

    const clearCamerasFilters = function () {
        setCameraFilterStatus(null);
        setCamerasAppliedFilters(null);
        setShowCamerasFilterPills(false);
    };

    const clearCamerasFilterByLabel = (label) => {
        switch (label) {
            case "Status":
                setCameraFilterStatus(null)
                break
            default:
                break
        }
    }

    const clearPdFilters = function () {
        setPayDisplayFilterStatus(null);
        setPayDisplayAppliedFilters(null);
        setShowPayDisplayFilterPills(false);
    };

    const clearPdFilterByLabel = (label) => {
        switch (label) {
            case "Status":
                setPayDisplayFilterStatus(null)
                break
            default:
                break
        }
    }

    const clearAllowListFilters = function () {
        setFilterStart(null);
        setFilterEnd(null);
        setFilterPeriodType("0");
        setCreatedByUserId(null);
        setCreatedBySource(null);
        setAllowListAppliedFilters(null);
        setShowAllowListFilterPills(false);
        setPageNumber(0);
        const sortPreference = StringHelpers.sortPreference(`${props.user.id}-allowListSortPreference`);
        getAllowList(search, null, null, 0, "0", sortPreference.sortBy, sortPreference.sortDirection, null, null)
    };

    const clearAllowListFilterByLabel = (label) => {
        const sortPreference = StringHelpers.sortPreference(`${props.user.id}-allowListSortPreference`);
        switch (label) {
            case "Created By":
                setCreatedByUserId(null)
                setCreatedBySource(null)
                getAllowList(search, filterStart, filterEnd, 0, filterPeriodType, sortPreference.sortBy, sortPreference.sortDirection, null, null)
                break
            case "Period Type":
                setFilterPeriodType("0")
                getAllowList(search, filterStart, filterEnd, 0, "0", sortPreference.sortBy, sortPreference.sortDirection, createdByUserId, createdBySource)
                break
            case "From":
                setFilterStart(null)
                getAllowList(search, null, filterEnd, 0, filterPeriodType, sortPreference.sortBy, sortPreference.sortDirection, createdByUserId, createdBySource)
                break
            case "To":
                setFilterEnd(null)
                getAllowList(search, filterStart, null, 0, filterPeriodType, sortPreference.sortBy, sortPreference.sortDirection, createdByUserId, createdBySource)
                break
            case "Date Range":
                setFilterStart(null)
                setFilterEnd(null)
                getAllowList(search, null, null, 0, filterPeriodType, sortPreference.sortBy, sortPreference.sortDirection, createdByUserId, createdBySource)
                break
            default:
                break
        }
        setPageNumber(0)
    }

    const addNote = function () {
        if (note !== "" || note !== null) {
            Api.addSiteNote(
                () => getNotes(),
                (error) => console.log(error),
                note, props.organisationId, siteId, props.token
            )
        }
    };

    const getNotes = function () {
        Api.getSiteNotes(
            (data) => setNotes(data),
            (error) => console.log(error),
            props.organisationId, siteId, props.token
        )
    };

    const getClients = () => {
        Api.getClients(
            data => setClients(data),
            error => console.log(error),
            props.organisationId,
            props.token
        )
    }
    const getAllowList = function (query, start, end, page, filterPeriodType, sortBy, sortDirection, user, source) {
        setIsLoading(true)
        Api.searchAllowedVrms(
            (data) => {
                setAllowListData(data)
                setIsLoading(false)
            },
            (error) => {
                console.log(error)
                setIsLoading(false)
            },
            0,
            page,
            query,
            "",
            start,
            end,
            null,
            siteId,
            Number(filterPeriodType),
            sortBy,
            sortDirection,
            !StringHelpers.isNullOrEmpty(user) ? user : null,
            !StringHelpers.isNullOrEmpty(source) ? source : null,
            null,
            false,
            null,
            props.organisationId,
            props.token,
            true
        );
    };

    const getAllowListCreatedBy = function () {
        Api.getAllowListCreatedBy(
            data => setCreatedByOptions(data),
            error => console.log(error),
            props.organisationId,
            props.token
        )
    };

    const getVariableAnprRanges = () => Api.getSiteVariableAnprRanges(
        (data) => setVariableAnprRanges(data),
            error => console.log(error),
        siteId, props.organisationId, props.token
    )

    const getSite = function () {
        Api.getSite(
            (data) => {
                setSite(data)
            },
            (error) => console.log(error),
            siteId,
            props.organisationId,
            props.token,
        )
    };

    const getSiteContraventions = function () {
        Api.getSiteContraventions(
            (data) => setSiteContraventions(data),
            (error) => console.log(error),
            props.organisationId,
            siteId,
            props.token
        )
    };

    const getAllContraventions = function () {
        Api.getContraventions(
            (data) => setAllContraventions(data),
            (error) => console.log(error),
            props.organisationId,
            props.token
        )
    };

    const edit = function () {
        if (canSave) {
            Api.editSite(
                (data) => {
                    setDetailsInEdit(false);
                    setCamerasInEdit(false);
                    setContraventionsInEdit(false);
                    setAllowListInEdit(false);
                    setSite(data);
                    setErrorMessage("");
                },
                (error) => setErrorMessage(error.errorMessage),
                name, siteCode, iasIpcCode, status, Number(jurisdiction), addressLine1, addressLine2, addressLine3, postCode, townOrCity, iasEnabled, bpaEnabled, bpaCode, pofaEnabled, anprEnabled, maxAllowedParkingDuration, considerationPeriod, allowListEntryGrace, allowListExitGrace, allowListDurationGrace, !StringHelpers.isNullOrEmpty(contraventionsForOverStay) ? contraventionsForOverStay : null, !StringHelpers.isNullOrEmpty(contraventionsForNotOnAllowList) ? contraventionsForNotOnAllowList : null, !StringHelpers.isNullOrEmpty(contraventionsForShortReturn) ? contraventionsForShortReturn : null,
                parkingSessionLimit, noReturnWithin, StringHelpers.isNullOrEmpty(contractExpiry) ? null : contractExpiry, payAndDisplaySpaces, preAllocatedSpaces, disabledSpaces, permitSpaces, otherSpaces,
                permitPrefix, parkonomySiteCode, ringGoZone, payByPhoneLocationId, justParkLocationId, tap2ParkLocationId, parkBunnyLocationId, ipsLocationId, conviousLocationId, !StringHelpers.isNullOrEmpty(contraventionsForOverStayPaymentPeriod) ? contraventionsForOverStayPaymentPeriod : null, !StringHelpers.isNullOrEmpty(contraventionsForFailToPay) ? contraventionsForFailToPay : null, isPayDisplay, overnightStaySettingsEnabled ? overnightStayContraventionId : null, StringHelpers.midnightOffsetToTimeString(overnightStayStartTime), StringHelpers.midnightOffsetToTimeString(overnightStayEndTime), Number(overnightStayGraceMinutes), StringHelpers.isNullOrEmpty(maximumCancellationsPerMonth) ? null : Number(maximumCancellationsPerMonth), !StringHelpers.isNullOrEmpty(autoAssignedUser) ? autoAssignedUser : null, vehicleAnalyticsEnabled, regionId, lookingForCarParkLocationId, newParkLocationId, parksoLocationId, freeParkingMinutes, myCarPassLocationId, preventDuplicateBreaches, site.enforceShortReturnForAllowListEntries, !StringHelpers.isNullOrEmpty(debtCollectionProviderId) ?  debtCollectionProviderId : null,
                props.organisationId,
                siteId,
                clientId,
                props.token
            );
        } else {
            setErrorMessage("There are validation errors.")
        }
    };

    const getAllTags = function () {
        Api.getTags(
            (data) => setAllTags(data),
            () => console.log("no tag found"),
            props.organisationId,
            props.token,
        )
    };

    const getCameras = function () {
        Api.getSiteCameras(
            (data) => setCameras(data),
            (error) => console.log(error),
            props.organisationId,
            siteId,
            props.token
        )
    };

    const getPdMachines = function () {
        Api.getSitePayDisplays(
            (data) => setPdMachines(data),
            (error) => console.log(error),
            siteId,
            props.organisationId,
            props.token
        )
    };

    const updateTag = (isAdding, tagId) => {
        if (!isAdding) {
            Api.deleteSiteTag(
                data => {
                    if (data.isError) {
                        setTagUpdateError(true)
                    } else {
                        setSelectedTags(previousTagIds => (previousTagIds || []).filter(selectedTagId => selectedTagId !== tagId))
                        setTagUpdateError(false)
                    }
                },
                error => setTagUpdateError(true),
                props.organisationId,
                siteId,
                tagId,
                props.token
            )
        } else {
            Api.addSiteTag(
                data => {
                    if (data.isError) {
                        setTagUpdateError(true)
                    } else {
                        setSelectedTags(previousTagIds => [...(previousTagIds || []), tagId])
                        setTagUpdateError(false)
                    }
                },
                error => setTagUpdateError(true),
                props.organisationId,
                siteId,
                tagId,
                props.token
            )
        }
    };

    const selectedTagDetails = !arrayUtilities.isNullOrEmpty(selectedTags) && !arrayUtilities.isNullOrEmpty(allTags)
        ? selectedTags
            .map(selectedTagId => allTags.find(tag => tag.id === selectedTagId))
            .filter(tag => tag !== undefined)
        : [];

    const getAttachments = function () {
        const isInitialAttachmentsLoad = attachments === null
        Api.getSiteAttachments(
            (data) => {
                setAttachments(data)
                if (isInitialAttachmentsLoad) {
                    const hasImages = data.some(item => item.isImage)
                    const hasDocuments = data.some(item => !item.isImage)
                    if (!hasImages && hasDocuments) {
                        setAttachmentsDefaultTab("files")
                    }
                }
            },
            (error) => console.log(error),
            props.organisationId,
            siteId, props.token
        )
    };

    const onSelectFiles = function (e) {

        if (e.target.files && e.target.files.length > 0) {
            setAttachmentUploadComplete(false);
            setAttachmentUploadError(false);
            setAttachmentUploadProgress(1);

            let newUploads = [];
            for (let i = 0; i < e.target.files.length; i++) {
                newUploads.push({ file: e.target.files[i] });
                const payload = new FormData();
                payload.append('file', e.target.files[i]);

                const xhr = new XMLHttpRequest();


                xhr.upload.onerror = (e) => {
                    setAttachmentUploadError(true);
                    setAttachmentUploadComplete(false);
                };

                xhr.onreadystatechange = function () {

                    if (xhr.readyState === 4) {
                        if (xhr.status === 200) {
                            setAttachmentUploadError(false);
                            setAttachmentUploadComplete(true);

                            let result = JSON.parse(xhr.response);
                            setAttachmentFileIds(prevState => [...prevState, result.id]);
                        } else {
                            setAttachmentUploadError(true);
                            setAttachmentUploadComplete(false);
                        }
                    }
                };

                xhr.upload.onprogress = (e) => {

                    let done = e.position || e.loaded;
                    let total = e.totalSize || e.total;
                    let perc = Math.max(1, Math.floor(done / total * 1000) / 10);
                    setAttachmentUploadProgress(perc);
                };

                xhr.open('POST', "https://api.advancedparking.tech/" + props.organisationId + '/attachments/upload', true);
                xhr.send(payload);
            }
            setAttachmentUploads(prevState => [...prevState, ...newUploads]);
        }
        e.target.value = null;
    };

    const selectFiles = function () {
        document.getElementById("upload-files-select").click();
    };

    const addToSiteAllowList = function () {
        if (canAddAllowList) {
            Api.addAllowedVrm(
                (data) => {
                    if (data.isError) {
                        setAllowListError(data.errorMessage)
                    } else {
                        const sortPreference = StringHelpers.sortPreference(`${props.user.id}-allowListSortPreference`);
                        getAllowList(search, filterStart, filterEnd, pageNumber, filterPeriodType, sortPreference.sortBy, sortPreference.sortDirection, createdByUserId, createdBySource);
                        setAllowListClientId("");
                        setAnprCameraId(null)
                        setAllowListItemSiteGroup("");
                        setRoi("");
                        setTabActiveKey("site");
                    }
                },
                (error) => {
                    console.log(error);
                    setAllowListError(error.errorMessage)
                    setAllowListClientId("");
                    setAnprCameraId(null)
                    setAllowListItemSiteGroup("");
                    setRoi("");
                    setTabActiveKey("site");
                },
                vrm, vehicleMake, vehicleModel, colour, reference, driverName, driverMobileNumber, StringHelpers.isNullOrEmpty(startDate) ? null: new Date(startDate).toISOString(), StringHelpers.isNullOrEmpty(endDate) ? null : new Date(endDate).toISOString(), 
                validOnlyAtSpecificTimes ? enabledFromTime + ':00' : null,
                validOnlyAtSpecificTimes ? enabledToTime + ':00' : null,
                isValidMonday,
                isValidTuesday,
                isValidWednesday,
                isValidThursday,
                isValidFriday,
                isValidSaturday,
                isValidSunday,
                reason, ((tabActiveKey === "global" || tabActiveKey === "client") || StringHelpers.isNullOrEmpty(siteId)) ? null : siteId, 
                ((tabActiveKey === "global" || tabActiveKey === "site") || StringHelpers.isNullOrEmpty(allowListClientId)) ? null : allowListClientId, anprCameraId, roi,
                !StringHelpers.isNullOrEmpty(allowListItemSiteGroup) ? allowListItemSiteGroup : null,
                !StringHelpers.isNullOrEmpty(blueBadgeNumber) ? blueBadgeNumber : null,
                !StringHelpers.isNullOrEmpty(blueBadgeExpiryDate) ? blueBadgeExpiryDate : null,
                maxStayMinutes,
                noReturnWithinMinutes,
                props.organisationId,
                props.token
            )
        }
    };

    const getAllKiosksBySite = () => {
        Api.getAllKiosksBySite(
            data => setKiosks(data),
            () => {},
            props.organisationId,
            siteId,
            props.token
        )
    }

    const getSiteGroups = () => {
        Api.getSiteGroupsBySiteId(
            props.organisationId, siteId, 
            data => setSiteGroups(data),
            error => console.log(error),
            props.token
        )
    }

    useEffect(() => {
        getSite();
        setContraventionUrl("/organisation/" + props.organisationId + "/site/" + siteId + "/contravention");
        setPayDisplayUrl("/organisation/" + props.organisationId + "/site/" + siteId + "/pay-display-machine");
        getPdMachines();
        getCameras();
        getClients();
        getSiteContraventions();
        getNotes();
        getAttachments();
        setClientUrl("/organisation/" + props.organisationId + '/client/' + clientId);
        getAllContraventions();
        getAllTags();
        const sortPreference = StringHelpers.sortPreference(`${props.user.id}-allowListSortPreference`);
        getAllowList(search, filterStart, filterEnd, 0, filterPeriodType, sortPreference.sortBy, sortPreference.sortDirection, createdByUserId, createdBySource);
        getAllowListCreatedBy();
        getAllKiosksBySite();
        getSiteGroups();
        getSuspensions()
        getVariableAnprRanges()
    }, []);

    useEffect(() => {
        if (StringHelpers.isNullOrEmpty(name) || StringHelpers.isNullOrEmpty(siteCode) || StringHelpers.isNullOrEmpty(addressLine1) || StringHelpers.isNullOrEmpty(townOrCity) || StringHelpers.isNullOrEmpty(postCode) || (overnightStaySettingsEnabled && StringHelpers.isNullOrEmpty(overnightStayContraventionId)) || (contraventionsForOverStayEnabled && StringHelpers.isNullOrEmpty(contraventionsForOverStay)) || (contraventionsForNotOnAllowListEnabled && StringHelpers.isNullOrEmpty(contraventionsForNotOnAllowList)) || (contraventionsForShortReturnEnabled && StringHelpers.isNullOrEmpty(contraventionsForShortReturn))) {
            setCanSave(false);
        } else {
            setCanSave(true);
        }
    }, [name, siteCode, addressLine1, townOrCity, postCode, overnightStaySettingsEnabled, overnightStayContraventionId, contraventionsForOverStayEnabled, contraventionsForOverStay, contraventionsForNotOnAllowListEnabled, contraventionsForNotOnAllowList, contraventionsForShortReturnEnabled, contraventionsForShortReturn]);

    const addAttachments = () => {
        if (!arrayUtilities.isNullOrEmpty(attachmentFileIds)) {
            setIsSavingAttachments(true)
            for (let i = 0; i < attachmentFileIds.length; i++) {
                Api.addSiteAttachment(
                    () => {
                        if (i === attachmentFileIds.length - 1) {
                            setIsSavingAttachments(false)
                            setAttachmentFileIds([])
                            setAttachmentUploads([])
                            getAttachments()
                        }
                    },
                    (error) => {
                        console.log(error)
                        setAttachmentUploads([])
                        setAttachmentFileIds([])
                        setIsSavingAttachments(false)
                    },
                    attachmentFileIds[i], StringHelpers.isNullOrEmpty(attachmentValidFrom) ? null : attachmentValidFrom, StringHelpers.isNullOrEmpty(attachmentValidTo) ? null : attachmentValidTo, props.organisationId, siteId, props.token
                )
            }
        }
    }

    useEffect(() => {
        if (StringHelpers.isNullOrEmpty(vrm) || !StringHelpers.isValidVrm(vrm) || !isToDateAfterFromDate(startDate, endDate)) {
            setCanAddAllowList(false);
        } else {
            setCanAddAllowList(true);
        }

    }, [vrm, startDate, endDate]);

    const getSuspensions = (id) => {
        Api.getSuspensions(
            data => {
                if (siteId && !arrayUtilities.isNullOrEmpty(data.items)) {
                    setShowSuspensionWarning(true)
                }
            },
            error => console.log(error),
            null, 0, 100, [id], startOfDay(new Date()), endOfDay(new Date()), null,
            props.organisationId, props.token
        )
    }

    useEffect(() => {
        if (site !== null) {
            setSiteId(site.id);
            setSelectedTags(!arrayUtilities.isNullOrEmpty(site.tags) ? site.tags.map(tag => tag.id) : []);
            //details
            setName(site.name);
            setSiteCode(site.siteCode);
            setRegionId(site.regionId);
            setDebtCollectionProviderId(!StringHelpers.isNullOrEmpty(site.debtCollectionProviderId) ? site.debtCollectionProviderId : "");
            setParkonomySiteCode(site.parkonomySiteCode);
            setParkBunnyLocationId(site.parkBunnyLocationId);
            setJustParkLocationId(site.justParkLocationId);
            setTap2ParkLocationId(site.tap2ParkLocationId);
            setPayByPhoneLocationId(site.payByPhoneLocationId);
            setIpsLocationId(site.ipsLocationId);
            setConviousLocationId(site.conviousLocationId);
            setLookingForCarParkLocationId(site.lookingForCarParkLocationId);
            setNewParkLocationId(site.newParkLocationId);
            setParksoLocationId(site.parksoLocationId);
            setMyCarPassLocationId(site.myCarPassLocationId);
            setRingGoZone(site.ringGoZone);
            setPermitPrefix(site.permitPrefix);
            setIasIpcCode(site.iasCode);
            setStatus(site.isActive);
            setAllowCancellationOfBreaches(site.maximumCancellationsPerMonth && site.maximumCancellationsPerMonth !== null && site.maximumCancellationsPerMonth > 0);
            setEnableAutoAssignUser(!StringHelpers.isNullOrEmpty(site.autoAssignUserId))
            setAutoAssignUser(!StringHelpers.isNullOrEmpty(site.autoAssignUserId) ? site.autoAssignUserId : "")
            setVehicleAnalyticsEnabled(site.vehicleAnalyticsEnabled)
            setPreventDuplicateBreaches(site.preventDuplicateBreaches)
            setMaximumCancellationsPerMonth(site.maximumCancellationsPerMonth === null ? "" : String(site.maximumCancellationsPerMonth));
            setContractExpiry(site.contractExpiry);
            setJurisdiction(String(site.jurisdiction));
            setAddressLine1(site.addressLine1);
            setAddressLine2(site.addressLine2);
            setAddressLine3(site.addressLine3);
            setTownOrCity(site.townOrCity);
            setPostCode(site.postCode);
            setIasEnabled(site.iasEnabled);
            setBpaEnabled(site.bpaEnabled);
            setBpaCode(site.bpaCode);
            setPofaEnabled(site.pofaEnabled);
            //cameras
            setAnprEnabled(site.isAnprEnabled);
            setMaxAllowedParkingDuration(site.maxAllowedParkingDurationMinutes);
            setConsiderationPeriod(site.considerationPeriodMinutes);
            setAllowListEntryGrace(site.allowListEntryGraceMinutes);
            setAllowListExitGrace(site.allowListExitGraceMinutes);
            setAllowListDurationGrace(site.allowListDurationGraceMinutes)
            setParkingSessionLimit(site.enforcementLimitMinutes);
            setNoReturnWithin(site.noReturnWithinMinutes);
            
            //spaces
            setPayAndDisplaySpaces(site.payAndDisplaySpaces);
            setPreAllocatedSpaces(site.preAllocatedSpaces);
            setDisabledSpaces(site.disabledSpaces);
            setPermitSpaces(site.permitSpaces);
            setOtherSpaces(site.otherSpaces);
            //contraventions
            setContraventionsForOverStayEnabled(!StringHelpers.isNullOrEmpty(site.overstayContraventionId))
            setContraventionsForOverStay(site.overstayContraventionId)
            setContraventionsForNotOnAllowListEnabled(!StringHelpers.isNullOrEmpty(site.notOnAllowListContraventionId))
            setContraventionsForNotOnAllowList(site.notOnAllowListContraventionId)
            setContraventionsForShortReturnEnabled(!StringHelpers.isNullOrEmpty(site.shortReturnContraventionId))
            setContraventionsForShortReturn(site.shortReturnContraventionId)
            setContraventionsForFailToPay(site.failedToMakePaymentContraventionId)
            
            
            setContraventionsForOverStayPaymentPeriod(site.overstayedPaymentPeriodContraventionId)
            setFreeParkingMinutes(site.freeParkingMinutes)
            setIsPayDisplay(site.isPayAndDisplayEnabled);
            
            // overnight stay
            setOvernightStaySettingsEnabled(!StringHelpers.isNullOrEmpty(site.overnightStayContraventionId));
            setOvernightStayContraventionId(site.overnightStayContraventionId)
            setOvernightStayGraceMinutes(site.overnightStayGraceMinutes)

            setOvernightStayStartTime(site.overnightStayStartTime !== null
                ? StringHelpers.timeStringToMidnightOffset(site.overnightStayStartTime)
                : 60)

            setOvernightStayEndTime(site.overnightStayEndTime !== null
                ? StringHelpers.timeStringToMidnightOffset(site.overnightStayEndTime)
                : 300)
            //url
            setCameraUrl("/organisation/" + props.organisationId + '/site/' + siteId + '/camera')
            getSuspensions(site.id)
        }
        setErrorMessage("");
    }, [site, detailsInEdit, camerasInEdit, contraventionsInEdit, allowListInEdit]);

    const changeSearchQuery = function(query) {
        setPageNumber(0);
        setSearch(query);
        const sortPreference = StringHelpers.sortPreference(`${props.user.id}-allowListSortPreference`);
        getAllowList(query, filterStart, filterEnd, 0, filterPeriodType, sortPreference.sortBy, sortPreference.sortDirection, createdByUserId, createdBySource)
    }

    const changePageNumber = function (num) {
        setPageNumber(num);
        const sortPreference = StringHelpers.sortPreference(`${props.user.id}-allowListSortPreference`);
        getAllowList(search, filterStart, filterEnd, num, filterPeriodType, sortPreference.sortBy, sortPreference.sortDirection, createdByUserId, createdBySource)
    };

    const handleSortTriggerClick = (sortBy, sortDirection) => {
        getAllowList(search, filterStart, filterEnd, pageNumber, filterPeriodType, sortBy, sortDirection, createdByUserId, createdBySource);
        if (currentSortBy !== sortBy) {
            setCurrentSortBy(sortBy)
        }
    }

    const vehicleLookup = () => {
        setLoadingVehicleLookup(true)
        Api.vehicleLookup(
            data => {
                if (data.isError) {
                    setVehicleLookupError(data.errorMessage)
                } else {
                    setVehicleMake(data.vehicleMake)
                    setVehicleModel(data.vehicleModel)
                    setColour(data.vehicleColour)
                    setSuccessfulLookupVrm(vrm)
                    setVehicleLookupError(null)
                }
                setLoadingVehicleLookup(false)
            },
            () => {
                setVehicleLookupError("Error locating details")
                setLoadingVehicleLookup(false)
            },
            vrm,
            props.organisationId, props.token
        )
    }

    const deleteAttachment = () => {
        Api.deleteSiteAttachment(
            () => { 
                setAttachmentUpdateError(null); 
                setDeleteAttachmentId(null); 
                getAttachments()
            },
            error => {
                console.log(error)
                setAttachmentUpdateError(error.errorMessage)
                setDeleteAttachmentId(null)
            },
            deleteAttachmentId, props.organisationId, siteId, props.token
        )
    }

    const editAttachment = () => {
        if (editableAttachment) {
            setIsSavingAttachments(true)
            Api.editSiteAttachment(
                data => {
                    if (data.isError) {
                        setIsSavingAttachments(false)
                        setAttachmentUpdateError(data.errorMessage)
                        setEditableAttachment(null)
                        setAttachmentValidFrom(null)
                        setAttachmentValidTo(null)
                    } else {
                        setIsSavingAttachments(false)
                        setEditableAttachment(null)
                        setAttachmentValidFrom(null)
                        setAttachmentValidTo(null)
                        setAttachmentUpdateError(null)
                        getAttachments()
                    }
                },
                (error) => {
                    console.log(error)
                    setAttachmentUpdateError(error.errorMessage)
                    setEditableAttachment(null)
                    setAttachmentValidFrom(null)
                    setAttachmentValidTo(null)
                    setIsSavingAttachments(false)
                },
                editableAttachment.id, StringHelpers.isNullOrEmpty(attachmentValidFrom) ? null : attachmentValidFrom, StringHelpers.isNullOrEmpty(attachmentValidTo) ? null : attachmentValidTo, props.organisationId, siteId, props.token
            )
        }
    }

    const renderUsername = () => {
        const user = props.users.find(item => item.id === autoAssignedUser)
        if (user !== undefined) {
            return `${user.firstName} ${user.lastName}`
        }
    }
    
    const handleKioskDelete = () => {
        Api.deleteSiteKiosk(
            data => {
                if (data.isError) {
                    setErrorMessage(data.errorMessage)
                } else {
                    getAllKiosksBySite()
                }
                setDeleteKiosk(null)
            },
            error => {
                setDeleteKiosk(null)
                setErrorMessage(error.message)
            },
            props.organisationId, siteId, deleteKiosk.id, props.token
        )
    }

    return (
        <>
            {
                !site ? <Loader /> 
                :<div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                {showSuspensionWarning && <div className="mb-3">
                                    <div className="d-flex align-items-center mb-3 alert alert-warning">
                                        <div><i className='fas fa-exclamation-triangle text-warning mr-2'></i></div>
                                        <div className="ml-2">
                                            <h6 className="m-0 fs--1 text-warning">This site has an active <Link className="text-warning font-weight-bold" to={{
                                                pathname:`/organisation/${props.organisationId}/enforcement-suspensions`,state:{ siteId:siteId }
                                            }}>suspension</Link>.</h6>
                                        </div>
                                    </div>
                                </div>}
                                <div className="card mb-3">
                                    <div className="card-header">
                                        <div className="row d-flex justify-content-between align-items-center">
                                            <div className="d-flex align-items-center pl-3">
                                                <h5 className="mb-0">Site - {site.name}</h5>
                                                <div className="d-flex align-items-center ml-2">
                                                    {
                                                        selectedTagDetails.map((tag) =>
                                                            <div
                                                                key={ tag.id }
                                                                className="d-flex align-items-center badge badge-pill badge-light text-secondary py-2 px-2 border position-relative mr-2"
                                                            >
                                                                <i className="fas fa-circle mr-2 ml-1 mb-0 fs--1" style={ {
                                                                    color: `#${ tag.colourCode }`
                                                                } }></i>
                                                                <p className="m-0 mr-1">{ tag.name }</p>
                                                            </div>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                            <div className='d-flex align-items-center'>
                                                <Link className="btn btn-falcon-default btn-sm mr-3 py-1" type="button" to={clientUrl}><i className="fas fa-reply"></i> Back</Link>
                                            {!isThirdPartyUser && !roleUtilities.isOrganisationProcessor(props.user,props.organisationId) && <>
                                                <button className="btn btn-falcon-default btn-sm dropdown-toggle py-2 mr-3 dropdown-caret-none" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true"><i
                                                    className="fas fa-ellipsis-h"></i></button>
                                                <div className="dropdown-menu dropdown-menu-right" x-placement="bottom-start">
                                                    <button type="button" className="dropdown-item text-danger" data-toggle="modal" data-target="#deleteModal">
                                                        <i className="fas fa-times"></i> Delete Site
                                                    </button>
                                                </div>
                                            </>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card mb-3 details-container">
                                    <div className="card-header">
                                        <div className="row align-items-center">
                                            <div className="col">
                                                <h5 className="mb-0">Site Details</h5>
                                            </div>
                                            <div className="col-auto">
                                                {!isThirdPartyUser && !roleUtilities.isOrganisationProcessor(props.user,props.organisationId) &&
                                                    <button type="button" className="btn btn-primary btn-sm ml-2" onClick={() => setDetailsInEdit(!detailsInEdit)}>
                                                        <i className="fas fa-edit"></i> Edit</button>}
                                            </div>
                                        </div>
                                    </div>

                                    {!detailsInEdit && <DisplayGeneralDetails organisationId={props.organisationId} token={props.token} site={site} tags={selectedTagDetails} allowCancellationOfBreaches={allowCancellationOfBreaches} enableAutoAssignUser={enableAutoAssignUser}
                                                                              autoAssignUsername={renderUsername()}/>}
                                    {detailsInEdit && <>
                                        <div className="card-body bg-light border-top details-container">
                                            {errorMessage !== "" && <div className="row">
                                                <div className="offset-md-3 col-md-6">
                                                    <p className="error-message">
                                                        {errorMessage}
                                                    </p>
                                                </div>
                                            </div>}
                                            <FormSiteGeneralDetails name={name} setName={setName} siteCode={siteCode} setSiteCode={setSiteCode} permitPrefix={permitPrefix} setPermitPrefix={setPermitPrefix} contractExpiry={contractExpiry}
                                                                    setContractExpiry={setContractExpiry} status={status} setStatus={setStatus} allowCancellationOfBreaches={allowCancellationOfBreaches}
                                                                    setAllowCancellationOfBreaches={setAllowCancellationOfBreaches} maximumCancellationsPerMonth={maximumCancellationsPerMonth}
                                                                    setMaximumCancellationsPerMonth={setMaximumCancellationsPerMonth} enableAutoAssignUser={enableAutoAssignUser} setEnableAutoAssignUser={setEnableAutoAssignUser}
                                                                    autoAssignedUser={autoAssignedUser} setAutoAssignUser={setAutoAssignUser} 
                                                                    jurisdiction={jurisdiction} setJurisdiction={setJurisdiction} addressLine1={addressLine1} setAddressLine1={setAddressLine1} addressLine2={addressLine2}
                                                                    setAddressLine2={setAddressLine2} addressLine3={addressLine3} setAddressLine3={setAddressLine3} townOrCity={townOrCity} setTownOrCity={setTownOrCity} postCode={postCode}
                                                                    setPostCode={setPostCode} isNew={false} allTags={allTags} selectedTags={selectedTags} updateTag={(isAdding, tagId) => updateTag(isAdding, tagId)} users={props.users}
                                                                    vehicleAnalyticsEnabled={vehicleAnalyticsEnabled} setVehicleAnalyticsEnabled={setVehicleAnalyticsEnabled}
                                                                    preventDuplicateBreaches={preventDuplicateBreaches} setPreventDuplicateBreaches={setPreventDuplicateBreaches} organisationId={props.organisationId} regionId={regionId}
                                                                    setRegionId={setRegionId} debtCollectionProviderId={debtCollectionProviderId} setDebtCollectionProviderId={setDebtCollectionProviderId} token={props.token}/>
                                            {
                                                tagUpdateError && <ErrorModal message="There was an error updating this tag" onHide={() => setTagUpdateError(false)} />
                                            }
                                            <FormSitePaymentProviders parkonomySiteCode={parkonomySiteCode} setParkonomySiteCode={setParkonomySiteCode} ringGoZone={ringGoZone} setRingGoZone={setRingGoZone}
                                                                      parkBunnyLocationId={parkBunnyLocationId} setParkBunnyLocationId={setParkBunnyLocationId} justParkLocationId={justParkLocationId}
                                                                      setJustParkLocationId={setJustParkLocationId} tap2ParkLocationId={tap2ParkLocationId} setTap2ParkLocationId={setTap2ParkLocationId}
                                                                      payByPhoneLocationId={payByPhoneLocationId} setPayByPhoneLocationId={setPayByPhoneLocationId} ipsLocationId={ipsLocationId} setIpsLocationId={setIpsLocationId}
                                                                      conviousLocationId={conviousLocationId} setConviousLocationId={setConviousLocationId}
                                                                      lookingForCarParkLocationId={lookingForCarParkLocationId} setLookingForCarParkLocationId={setLookingForCarParkLocationId}
                                                                      newParkLocationId={newParkLocationId} setNewParkLocationId={setNewParkLocationId}
                                                                      parksoLocationId={parksoLocationId} setParksoLocationId={setParksoLocationId}
                                                                      myCarPassLocationId={myCarPassLocationId} setMyCarPassLocationId={setMyCarPassLocationId}/>

                                            <FormSiteCodes iasEnabled={iasEnabled} setIasEnabled={setIasEnabled} iasIpcCode={iasIpcCode} setIasIpcCode={setIasIpcCode} bpaEnabled={bpaEnabled} setBpaEnabled={setBpaEnabled} bpaCode={bpaCode}
                                                           setBpaCode={setBpaCode} pofaEnabled={pofaEnabled} setPofaEnabled={setPofaEnabled}/>

                                            <FormSiteSpaces payAndDisplaySpaces={payAndDisplaySpaces} setPayAndDisplaySpaces={setPayAndDisplaySpaces} preAllocatedSpaces={preAllocatedSpaces} setPreAllocatedSpaces={setPreAllocatedSpaces}
                                                            disabledSpaces={disabledSpaces} setDisabledSpaces={setDisabledSpaces} permitSpaces={permitSpaces} setPermitSpaces={setPermitSpaces} otherSpaces={otherSpaces}
                                                            setOtherSpaces={setOtherSpaces}/>
                                        </div>
                                        <div className="card-footer border-top ">
                                            <div className="row client-edit-buttons">
                                                <div className="col-6 col-sm-auto ml-auto  pl-0">
                                                    <div id="dashboard-actions">
                                                        <button type="button" className="btn btn-falcon-default btn-sm ml-2" onClick={() => setDetailsInEdit(false)}>
                                                            <i className="fas fa-times"></i> Cancel
                                                        </button>
                                                        <button type="button" className="btn btn-success btn-sm ml-2" disabled={!canSave} onClick={() => edit()}>
                                                            <i className="fas fa-check"></i> Confirm
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>}
                                </div>

                                <div className="card mb-3">
                                    <div className="card-header">
                                        <div className="row align-items-center">
                                            <div className="col">
                                                <h5 className="mb-0">
                                                    <button className="button-no-style button-card-header collapsed" id="site-contras" type="button" data-toggle="collapse" data-target="#site-contras-list" aria-expanded="true"
                                                            aria-controls="site-contras-list">
                                                        Site Contraventions <i className="fas fa-chevron-down"></i>
                                                    </button>
                                                </h5>
                                            </div>
                                        </div>
                                    </div>
                                    {siteContraventions && allContraventions && (allContraventions.length !== 0) &&
                                        <div className="card-body bg-light border-top details-container collapse" id="site-contras-list" aria-labelledby="Site Contraventions List" data-parent="#site-contras">
                                            <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer">
                                                <thead className="bg-200 text-900">
                                                <tr>
                                                    <th>Contravention</th>
                                                    <th>Type</th>
                                                    <th className="text-center">Status</th>
                                                    <th className="text-right">Reduced Charge Amount</th>
                                                    <th className="text-right">Reduced Charge Days</th>
                                                    <th className="text-right">Full Charge Amount</th>
                                                    <th className="text-right">Full Charge Days</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {allContraventions.map((contravention) => {
                                                    var url = contraventionUrl + '/' + contravention.id;
                                                    var isActive = false;
                                                    let reducedAmount
                                                    let reducedDays
                                                    let fullAmount
                                                    let fullDays
                                                    const siteContravention = siteContraventions.find(item => contravention.id === item.contraventionId)
                                                    if ( siteContravention !== undefined ) {
                                                        isActive = siteContravention.isActive;
                                                        reducedAmount = siteContravention.reducedChargeAmount ?? contravention.reducedChargeAmount
                                                        reducedDays = siteContravention.reducedChargeDays ?? contravention.reducedChargeDays
                                                        fullAmount = siteContravention.fullChargeAmount ?? contravention.fullChargeAmount
                                                        fullDays = siteContravention.fullChargeDays ?? contravention.fullChargeDays
                                                    } else {
                                                        reducedAmount = contravention.reducedChargeAmount
                                                        reducedDays = contravention.reducedChargeDays
                                                        fullAmount = contravention.fullChargeAmount
                                                        fullDays = contravention.fullChargeDays
                                                    }

                                                    return (<tr key={contravention.id}>
                                                        <td><Link to={url}><h6 className="mb-0">{contravention.name}</h6></Link></td>
                                                        <td>{Enums.ContraventionTypes[contravention.contraventionType]}</td>
                                                        <td className="text-center">{isActive && <><i className="fas fa-check text-success"></i></>}{!isActive && <><i className="fas fa-times text-danger"></i></>}</td>
                                                        <td className="text-right">{StringHelpers.formatDecimal(reducedAmount,2,"£")}</td>
                                                        <td className="text-right">{StringHelpers.formatDecimal(reducedDays,0)}</td>
                                                        <td className="text-right">{StringHelpers.formatDecimal(fullAmount,2,"£")}</td>
                                                        <td className="text-right">{StringHelpers.formatDecimal(fullDays,0)}</td>
                                                    </tr>)
                                                })}
                                                </tbody>
                                            </table>
                                        </div>}
                                </div>

                                <div className="card mb-3">
                                    <div className="card-header">
                                        <div className="row align-items-center">
                                            <div className="col">
                                                <h5 className="mb-0">
                                                    <button className="button-no-style button-card-header collapsed" id="variable-anpr-settings-list" type="button" data-toggle="collapse" data-target="#variable-anpr-settings"
                                                            aria-expanded="true" aria-controls="variable-anpr-settings-list">
                                                        ANPR Settings <i className="fas fa-chevron-down"></i>
                                                    </button>
                                                </h5>
                                            </div>
                                            {!isThirdPartyUser && !roleUtilities.isOrganisationProcessor(props.user,props.organisationId) && <div className="col-auto">
                                                <Link to={`/organisation/${props.organisationId}/client/${clientId}/site/${siteId}/anpr-settings`} type="button" className="btn btn-success btn-sm">
                                                    <i className="fas fa-plus mr-2"></i>Add Variable ANPR</Link>
                                            </div>}
                                        </div>
                                    </div>
                                    <div className="collapse" id="variable-anpr-settings" aria-labelledby="Variable ANPR Settings List" data-parent="#variable-anpr-settings-list">
                                        <div className="card-body bg-light border-top px-0">
                                            {site && <SiteAnprSettingsTable
                                                organisationId={props.organisationId}
                                                site={site}
                                                clientId={clientId}
                                                variableAnprRows={variableAnprRanges}
                                                siteId={siteId}
                                                allContraventions={allContraventions}
                                                token={props.token}
                                                refresh={() => getVariableAnprRanges()}
                                                canUpdate={!isThirdPartyUser && !roleUtilities.isOrganisationProcessor(props.user,props.organisationId)}
                                            />}
                                        </div>
                                    </div>

                                </div>

                                <div className="card mb-3">
                                    <div className="card-header">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div>
                                                <h5 className="mb-0">
                                                    <button className="button-card-header button-no-style collapsed" id="cameras" type="button" data-toggle="collapse" data-target="#cameras-list" aria-expanded="true"
                                                            aria-controls="cameras-list">
                                                        Cameras <i className="fas fa-chevron-down"></i></button>
                                                </h5>
                                            </div>
                                            <div className="d-flex align-items-center">
                                                <div className='mr-2'>
                                                    <SearchBarWithDebounce onSearchQueryChange={ query => setCamerasSearch(query) } />
                                                </div>
                                                <div className='mr-2'>
                                                    <FiltersModalTrigger onClick={ () => setShowCamerasFiltersModal(true) } />
                                                </div>
                                                {!isThirdPartyUser && !roleUtilities.isOrganisationProcessor(props.user,props.organisationId) && <Link type="button" className="btn btn-success btn-sm ml-2 nowrap" to={cameraUrl}>
                                                    <i className="fas fa-plus"></i> Add</Link>}
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        showCamerasFilterPills && camerasAppliedFilters &&
                                        <div className="px-3 py-2 border-top d-flex align-items-center flex-wrap">
                                            {
                                                Object.entries(camerasAppliedFilters).map(
                                                    ([label, value]) => !StringHelpers.isNullOrEmpty(value)
                                                        && <div className="mr-2" key={ label }>
                                                            <AppliedFilterDisplay
                                                                label={ label }
                                                                onTextClick={ () => setShowCamerasFiltersModal(true) }
                                                                onCloseClick={ closedLabel => {
                                                                    clearCamerasFilterByLabel(closedLabel)
                                                                    setCamerasAppliedFilters(prevState => {
                                                                        const updatedFilters = { ...prevState }
                                                                        updatedFilters[closedLabel] = null
                                                                        const hasRemainingFilters = Object.values(updatedFilters).some(value => !StringHelpers.isNullOrEmpty(value))
                                                                        return hasRemainingFilters ? updatedFilters : null
                                                                    })
                                                                } }
                                                                value={ value }
                                                            />
                                                        </div>
                                                )
                                            }
                                            { camerasAppliedFilters && Object.keys(camerasAppliedFilters).length > 0 && <button type="button" className="btn btn-none p-0 m-0 fs--1 nowrap" onClick={ () => clearCamerasFilters() }>Clear all filters</button> }
                                        </div>
                                    }
                                    <div className="card-body bg-light border-top details-container collapse" id="cameras-list" aria-labelledby="Tag List" data-parent="#cameras">
                                        <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer ">
                                            <thead className="bg-200 text-900">
                                            <tr>
                                                <th>Camera Name</th>
                                                <th>Camera ID</th>
                                                <th className="text-center">Status</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {cameras && cameras.filter(function (item) {
                                                var name = new String(item.name).toLowerCase();
                                                return ((camerasSearch === null || name.search(camerasSearch.toLowerCase()) !== -1) && (cameraFilterStatus === item.isActive || cameraFilterStatus === null))
                                            }).map((camera) => {
                                                var url = cameraUrl + "/" + camera.id;
                                                return (<tr key={camera.id}>
                                                    <td><Link to={url}><h6 className="mb-0">{camera.name}</h6></Link></td>
                                                    <td>{camera.macAddress}</td>
                                                    <td className="text-center">{camera.isActive && <><i className="fas fa-check text-success"></i></>}{!camera.isActive && <><i className="fas fa-times text-danger"></i></>}</td>
                                                </tr>)
                                            })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="card mb-3">
                                    <div className="card-header">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div>
                                                <h5 className="mb-0">
                                                    <button className="button-card-header button-no-style collapsed" id="pd-machines" type="button" data-toggle="collapse" data-target="#pd-list" aria-expanded="true" aria-controls="pd-list">
                                                        Pay & Display Machines <i className="fas fa-chevron-down"></i></button>
                                                </h5>
                                            </div>
                                            <div className="d-flex align-items-center">
                                                <div className='mr-2'>
                                                    <SearchBarWithDebounce onSearchQueryChange={ query => setPayDisplaySearch(query) } />
                                                </div>
                                                <div className='mr-2'>
                                                    <FiltersModalTrigger onClick={ () => setShowPayDisplayFiltersModal(true) } />
                                                </div>
                                                {!isThirdPartyUser && !roleUtilities.isOrganisationProcessor(props.user,props.organisationId) && <Link type="button" className="btn btn-success btn-sm ml-2 nowrap" to={payDisplayUrl}>
                                                    <i className="fas fa-plus"></i> Add</Link>}
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        showPayDisplayFilterPills && payDisplayAppliedFilters &&
                                        <div className="px-3 py-2 border-top d-flex align-items-center flex-wrap">
                                            {
                                                Object.entries(payDisplayAppliedFilters).map(
                                                    ([label, value]) => !StringHelpers.isNullOrEmpty(value)
                                                        && <div className="mr-2" key={ label }>
                                                            <AppliedFilterDisplay
                                                                label={ label }
                                                                onTextClick={ () => setShowPayDisplayFiltersModal(true) }
                                                                onCloseClick={ closedLabel => {
                                                                    clearPdFilterByLabel(closedLabel)
                                                                    setPayDisplayAppliedFilters(prevState => {
                                                                        const updatedFilters = { ...prevState }
                                                                        updatedFilters[closedLabel] = null
                                                                        const hasRemainingFilters = Object.values(updatedFilters).some(value => !StringHelpers.isNullOrEmpty(value))
                                                                        return hasRemainingFilters ? updatedFilters : null
                                                                    })
                                                                } }
                                                                value={ value }
                                                            />
                                                        </div>
                                                )
                                            }
                                            { payDisplayAppliedFilters && Object.keys(payDisplayAppliedFilters).length > 0 && <button type="button" className="btn btn-none p-0 m-0 fs--1 nowrap" onClick={ () => clearPdFilters() }>Clear all filters</button> }
                                        </div>
                                    }
                                    <div className="card-body bg-light border-top details-container collapse" id="pd-list" aria-labelledby="Pay and Display Machines List" data-parent="#pd-machines">
                                        <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer ">
                                            <thead className="bg-200 text-900">
                                            <tr>
                                                <th>Name</th>
                                                <th>City Code</th>
                                                <th>Machine ID</th>
                                                <th>Flowbird Terminal ID</th>
                                                <th className="text-center">Status</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {pdMachines && pdMachines.filter(function (item) {
                                                var name = new String(item.name).toLowerCase();
                                                return ((payDisplaySearch === null || name.search(payDisplaySearch.toLowerCase()) !== -1) && (payDisplayFilterStatus === item.isActive || payDisplayFilterStatus === null))
                                            }).map((machine) => {
                                                var url = payDisplayUrl + "/" + machine.id;
                                                return (<tr>
                                                    <td><Link to={url}><h6 className="mb-0">{machine.name}</h6></Link></td>
                                                    <td>{machine.cityCode}</td>
                                                    <td>{machine.machineId}</td>
                                                    <td>{machine.flowbirdTerminalId}</td>
                                                    <td className="text-center">{machine.isActive && <><i className="fas fa-check text-success"></i></>}{!machine.isActive && <><i className="fas fa-times text-danger"></i></>}</td>
                                                </tr>)
                                            })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <ConfigurationUpdate
                                    id="kiosk-configuration"
                                    dataTarget="kiosk-config"
                                    title="Kiosks"
                                    ariaLabel="Kiosk Configuration Settings"
                                    handleHeaderAction={() => history.push(`/organisation/${props.organisationId}/site/${siteId}/kiosk`)}
                                    headerButtonText="Add"
                                    isActionAllowed={!isThirdPartyUser && !roleUtilities.isOrganisationProcessor(props.user,props.organisationId)}
                                >
                                    <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer ">
                                        <thead className="bg-200 text-900">
                                        <tr>
                                            <th>Kiosk Name</th>
                                            <th>Code</th>
                                            <th className="text-center">Web Kiosk Enabled</th>
                                            <th className="text-center">Kiosk App Enabled</th>
                                            {!isThirdPartyUser && !roleUtilities.isOrganisationProcessor(props.user,props.organisationId) && <th>&nbsp;</th>}
                                        </tr>
                                        </thead>


                                        <tbody>
                                        {!arrayUtilities.isNullOrEmpty(kiosks) && kiosks.map(kiosk => {
                                            const kioskUrl = `/organisation/${props.organisationId}/site/${siteId}/kiosk/${kiosk.id}`
                                            return (<tr key={kiosk.id}>
                                                <td><Link to={kioskUrl}><h6 className="mb-0">{kiosk.name}</h6></Link></td>
                                                <td className='text-monospace'>{kiosk.shortCode}</td>
                                                <td className='text-center'>{kiosk.isWebEnabled ? <i className="fas fa-check text-success"></i> : <i className="fas fa-times text-danger"></i>}</td>
                                                <td className='text-center'>{kiosk.isAppEnabled ? <i className="fas fa-check text-success"></i> : <i className="fas fa-times text-danger"></i>}</td>
                                                {!isThirdPartyUser && !roleUtilities.isOrganisationProcessor(props.user,props.organisationId) && <td className='text-right'>
                                                    <button onClick={() => setDeleteKiosk(kiosk)} className="btn btn-none p-0 m-0 ml-1"><i className="fas fa-trash-alt"></i></button>
                                                </td>}
                                            </tr>)
                                        })}
                                        </tbody>
                                    </table>
                                    {deleteKiosk && <Modal show onHide={() => setDeleteKiosk(null)}>
                                        <Modal.Header>
                                            <Modal.Title className='text-danger'>
                                                Delete Kiosk
                                            </Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            Are you sure you want to delete the kiosk <b>{deleteKiosk.name}</b>?
                                        </Modal.Body>
                                        <Modal.Footer>
                                            <button
                                                className="btn btn-falcon-default btn-sm"
                                                onClick={() => setDeleteKiosk(null)}
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                className="btn btn-sm btn-danger mt-1"
                                                onClick={handleKioskDelete}
                                            >
                                                Delete
                                            </button>
                                        </Modal.Footer>
                                    </Modal>}
                                    {!StringHelpers.isNullOrEmpty(errorMessage) && <ErrorModal message={errorMessage} onHide={() => setErrorMessage(null)}/>}
                                </ConfigurationUpdate>

                                <SiteDisallowListAccordion
                                    organisationId={props.organisationId}
                                    siteId={siteId}
                                    token={props.token}
                                    user={props.user}
                                    siteName={site.name}
                                />
                                <div className="card mb-3">
                                    <div className="card-header">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div className="">
                                                <h5 className="mb-0">
                                                    <button className="button-no-style button-card-header collapsed" id="site-allowed-vrms" type="button" data-toggle="collapse" data-target="#site-allow-list" aria-expanded="true"
                                                            aria-controls="site-allow-list">
                                                        Site Allow List <i className="fas fa-chevron-down"></i>
                                                    </button>
                                                </h5>
                                            </div>
                                            <div className="d-flex align-items-center">
                                                <div className='mr-2'>
                                                    <SearchBarWithDebounce onSearchQueryChange={ query => changeSearchQuery(query) } />
                                                </div>
                                                <div className='mr-2'>
                                                    <FiltersModalTrigger onClick={ () => setShowAllowListFiltersModal(true) } />
                                                </div>
                                                {!isThirdPartyUser && !roleUtilities.isOrganisationProcessor(props.user,props.organisationId) &&
                                                    <button className="btn btn-success btn-sm ml-1 nowrap" type="button" data-toggle="modal" data-target="#addToAllowList"><i className="fas fa-plus"></i> Add</button>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="modal fade" id="addToAllowList" tabIndex="-1" role="dialog" aria-labelledby="addNewModalLabel" aria-hidden="true">
                                        <div className="modal-dialog modal-dialog-scrollable site-allow-list modal-xl" role="document">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <h5 className="modal-title" id="addNewModalLabel">Add new VRM to the {site.name} allow list.</h5>
                                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                        <span aria-hidden="true">&times;</span>
                                                    </button>
                                                </div>
                                                <div className="modal-body details-container">
                                                    <h6 className="mb-3 fs-1">Vehicle Details</h6>
                                                    <div className="row">
                                                        <div className="col-md-4 col-12 ">
                                                            <p className="font-weight-semi-bold  mt-1 mb-1">VRM<span className="req"></span></p>
                                                        </div>
                                                        <div className="col-md-8 col-12 ">
                                                            <div className='d-flex align-items-start'>
                                                                <div className="form-group mb-1">
                                                                    <input disabled={loadingVehicleLookup} required className="form-control mb-1 small-number-plate" type="text" value={vrm}
                                                                           onChange={(e) => {
                                                                               if ( !StringHelpers.isNullOrEmpty(vehicleLookupError) ) {
                                                                                   setVehicleLookupError(null)
                                                                               }
                                                                               setVrm(e.target.value.toUpperCase())
                                                                               formUtilities.requiredField(e.target.parentNode,e.target.value)
                                                                           }}
                                                                    />
                                                                    <small className='invalid-feedback text-danger'>Please enter a VRM</small>

                                                                    {!StringHelpers.isNullOrEmpty(vrm) && <small className='text-danger'>
                                                                        {!StringHelpers.isValidVrm(vrm) ? <>Invalid VRM format</> : !StringHelpers.isNullOrEmpty(vehicleLookupError) && vehicleLookupError}
                                                                    </small>}
                                                                </div>
                                                                <button
                                                                    onClick={() => vehicleLookup()}
                                                                    disabled={StringHelpers.isNullOrEmpty(vrm) || !StringHelpers.isValidVrm(vrm) || (!StringHelpers.isNullOrEmpty(vrm) && !StringHelpers.isNullOrEmpty(successfulLookupVrm) && vrm === successfulLookupVrm) || loadingVehicleLookup}
                                                                    className='btn btn-falcon-default btn-sm ml-3 mt-2'
                                                                >
                                                                    <div className='d-flex align-items-center'>
                                                                        {loadingVehicleLookup ? <span className="tiny-loader mr-2"><Loader/></span> : <i className='fas fa-search mr-1'></i>}
                                                                        Vehicle Lookup
                                                                    </div>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4 col-12 ">
                                                            <p className="font-weight-semi-bold  mt-1 mb-1">Reference</p>
                                                        </div>
                                                        <div className="col-md-8 col-12 ">
                                                            <div className="form-group mb-1">
                                                                <input className="form-control mb-0" type="text" value={reference} onChange={(e) => setReference(e.target.value)}/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4 col-12 ">
                                                            <p className="font-weight-semi-bold  mt-1 mb-1">Vehicle Make</p>
                                                        </div>
                                                        <div className="col-md-8 col-12 ">
                                                            <div className="form-group mb-1">
                                                                <input disabled={loadingVehicleLookup} className="form-control mb-0" type="text" value={vehicleMake} onChange={(e) => setVehicleMake(e.target.value)}/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4 col-12 ">
                                                            <p className="font-weight-semi-bold  mt-1 mb-1">Vehicle Model</p>
                                                        </div>
                                                        <div className="col-md-8 col-12 ">
                                                            <div className="form-group mb-1">
                                                                <input disabled={loadingVehicleLookup} className="form-control mb-0" type="text" value={vehicleModel} onChange={(e) => setVehicleModel(e.target.value)}/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4 col-12 ">
                                                            <p className="font-weight-semi-bold  mt-1 mb-1">Colour</p>
                                                        </div>
                                                        <div className="col-md-8 col-12 ">
                                                            <div className="form-group mb-1">
                                                                <input disabled={loadingVehicleLookup} className="form-control mb-0" type="text" value={colour} onChange={(e) => setColour(e.target.value)}/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <hr className="border-dashed border-bottom-0"></hr>
                                                    <h6 className="mb-3 fs-1">Driver Details</h6>
                                                    <div className="row">
                                                        <div className="col-md-4 col-12 ">
                                                            <p className="font-weight-semi-bold  mt-1 mb-1">Name</p>
                                                        </div>
                                                        <div className="col-md-8 col-12">
                                                            <div className="form-group mb-0">
                                                                <input className="form-control mb-1" type="text" value={driverName} onChange={(e) => setDriverName(e.target.value)}/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4 col-12 ">
                                                            <p className="font-weight-semi-bold  mt-1 mb-1">Mobile Number</p>
                                                        </div>
                                                        <div className="col-md-8 col-12">
                                                            <div className="form-group mb-0">
                                                                <input className="form-control mb-1" type="text" value={driverMobileNumber} onChange={(e) => setDriverMobileNumber(e.target.value)}/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4 col-12 ">
                                                            <p className="font-weight-semi-bold  mt-1 mb-1">Email Address</p>
                                                        </div>
                                                        <div className="col-md-8 col-12">
                                                            <div className="form-group mb-1">
                                                                <input className="form-control mb-0" type="text" value={driverEmailAddress} onChange={(e) => setDriverEmailAddress(e.target.value)}/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4 col-12 ">
                                                            <p className="font-weight-semi-bold  mt-1 mb-1">Blue Badge Number</p>
                                                        </div>
                                                        <div className="col-md-8 col-12">
                                                            <div className="form-group mb-1">
                                                                <input className="form-control mb-0" type="text" value={blueBadgeNumber} onChange={(e) => setBlueBadgeNumber(e.target.value)}/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4 col-12 ">
                                                            <p className="font-weight-semi-bold  mt-1 mb-1">Blue Badge Expiry Date</p>
                                                        </div>
                                                        <div className="col-md-8 col-12">
                                                            <div className="form-group mb-1">
                                                                <input className="form-control mb-0" type="date" value={toInputFieldDateString(blueBadgeExpiryDate)} onChange={(e) => setBlueBadgeExpiryDate(e.target.value)}/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <hr className="border-dashed border-bottom-0"></hr>
                                                    <ClientSiteTabbed
                                                        clients={clients}
                                                        client={allowListClientId}
                                                        onTabChange={e => {
                                                            setAnprCameraId(null);
                                                            setAllowListItemSiteGroup("");
                                                            setAllowListClientId("");
                                                            setRoi("");
                                                            setTabActiveKey(e)
                                                        }}
                                                        anprCameraId={anprCameraId}
                                                        setAnprCameraId={setAnprCameraId}
                                                        site={site}
                                                        sites={null}
                                                        activeKey={tabActiveKey}
                                                        siteGroups={siteGroups}
                                                        siteGroup={allowListItemSiteGroup}
                                                        setSiteGroup={setAllowListItemSiteGroup}
                                                        anprCameras={cameras}
                                                        roi={roi}
                                                        setRoi={setRoi}
                                                        labelWidthClass='col-md-4 col-12'
                                                        fieldWidthClass='col-md-8 col-12'
                                                        setClient={setAllowListClientId}
                                                    />
                                                    <hr className="border-dashed border-bottom-0"></hr>
                                                    <div className="mandatory-date-time">
                                                        <div className="row mb-3">
                                                            <div className="col-md-4 col-12 ">
                                                                <h6 className="mb-3 fs-1">Date/Time Details</h6>
                                                            </div>
                                                            <div className="col-md-8 col-12">
                                                                <div className="d-flex align-items-center mb-1">
                                                                    <input checked={typeDateTime === "0"} id={"0"} onChange={() => {
                                                                        setTypeDateTime("0")
                                                                        setStartDate("")
                                                                        setEndDate("")
                                                                    }} className='mr-2' name="type-date-time-selection-radio" key={"0"} value={"0"} type='radio'/>
                                                                    <label className='m-0' htmlFor={"0"}>Indefinite (no start/end date)</label>
                                                                </div>

                                                                <div className="d-flex mb-1 align-items-start">
                                                                    <input checked={typeDateTime === "1"} id={"1"} onChange={() => {
                                                                        setTypeDateTime("1")
                                                                        setStartDate(toInputFieldDateTimeString(firstDate))
                                                                        setEndDate(toInputFieldDateTimeString(lastDate))
                                                                    }} className='mr-2 mt-1' name="type-date-time-selection-radio" key={"1"} value={"1"} type='radio'/>
                                                                    <div className="">
                                                                        <label className='m-0 d-flex flex-column' htmlFor={"1"}>
                                                                            Today
                                                                            <small>{toDateString(firstDate)}, {toTimeString(firstDate)} - {toTimeString(lastDate)}</small>
                                                                        </label>
                                                                    </div>
                                                                </div>

                                                                <div className="d-flex align-items-center mb-1">
                                                                    <input checked={typeDateTime === "2"} id={"2"} onChange={() => {
                                                                        setTypeDateTime("2")
                                                                        setStartDate("")
                                                                        setEndDate("")
                                                                    }} className='mr-2' name="type-date-time-selection-radio" key={"2"} value={"2"} type='radio'/>
                                                                    <label className='m-0' htmlFor={"2"}>Specific date range</label>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {typeDateTime === "2" && <>
                                                            <div className="row mb-3">
                                                                <div className="col-md-4 col-12 ">
                                                                    <p className="text-left font-weight-semi-bold  mt-1 mb-1">Date Range</p>
                                                                </div>
                                                                <div className="col-md-8 col-12 d-flex align-items-center">
                                                                    <div className="form-group mb-0">
                                                                        <DateTimePickerWithCustomDisplay
                                                                            customDisplayText="No start date"
                                                                            onChange={v => setStartDate(v)}
                                                                            value={toInputFieldDateTimeString(startDate)}
                                                                        />
                                                                    </div>
                                                                    <p className='m-0 mx-2'>To</p>
                                                                    <div className="form-group mb-0">
                                                                        <DateTimePickerWithCustomDisplay
                                                                            customDisplayText="No end date"
                                                                            onChange={v => setEndDate(v)}
                                                                            value={toInputFieldDateTimeString(endDate)}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="row mt-3">
                                                                <div className="col-md-4 col-12 ">
                                                                    <p className="text-left font-weight-semi-bold  mt-1 mb-1">Valid only on specific days</p>
                                                                </div>
                                                                <div className="col-md-8 col-12 custom-control custom-switch">
                                                                    <input className="custom-control-input" type="checkbox" id="valid-specific-days-toggle" checked={validOnlyOnSpecificDays} onChange={e => {
                                                                        setValidOnlyOnSpecificDays(!validOnlyOnSpecificDays)
                                                                        if ( !e.target.checked ) {
                                                                            setValidOnlyOnSpecificDays(false)
                                                                            setIsValidMonday(false)
                                                                            setIsValidTuesday(false)
                                                                            setIsValidWednesday(false)
                                                                            setIsValidThursday(false)
                                                                            setIsValidFriday(false)
                                                                            setIsValidSaturday(false)
                                                                            setIsValidSunday(false)
                                                                        }
                                                                    }}/>
                                                                    <label className="custom-control-label ml-3" htmlFor="valid-specific-days-toggle"></label>
                                                                    <p className="text-left m-0 ml-3 mt-1">{validOnlyOnSpecificDays ? <>Yes</> : <>No</>}</p>
                                                                </div>
                                                            </div>
                                                            <div className='mt-3'>
                                                                {validOnlyOnSpecificDays && <>
                                                                    <div className="row mb-3">
                                                                        <div className="col-md-4 col-12 ">
                                                                            <p className="font-weight-semi-bold  mt-1 mb-1">Monday</p>
                                                                        </div>
                                                                        <div className="col-md-8 col-12 custom-control custom-switch">
                                                                            <input className="custom-control-input" type="checkbox" id="enable-monday-switch" checked={isValidMonday}
                                                                                   onChange={e => setIsValidMonday(prevState => !prevState)}/>
                                                                            <label className="custom-control-label ml-3" htmlFor="enable-monday-switch"></label>
                                                                            <p className="m-0 ml-3 mt-1">{isValidMonday ? <>Yes</> : <>No</>}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row mb-3">
                                                                        <div className="col-md-4 col-12 ">
                                                                            <p className="font-weight-semi-bold  mt-1 mb-1">Tuesday</p>
                                                                        </div>
                                                                        <div className="col-md-8 col-12 custom-control custom-switch">
                                                                            <input className="custom-control-input" type="checkbox" id="enable-tuesday-switch" checked={isValidTuesday}
                                                                                   onChange={e => setIsValidTuesday(prevState => !prevState)}/>
                                                                            <label className="custom-control-label ml-3" htmlFor="enable-tuesday-switch"></label>
                                                                            <p className="m-0 ml-3 mt-1">{isValidTuesday ? <>Yes</> : <>No</>}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row mb-3">
                                                                        <div className="col-md-4 col-12 ">
                                                                            <p className="font-weight-semi-bold  mt-1 mb-1">Wednesday</p>
                                                                        </div>
                                                                        <div className="col-md-8 col-12 custom-control custom-switch">
                                                                            <input className="custom-control-input" type="checkbox" id="enable-wednesday-switch" checked={isValidWednesday}
                                                                                   onChange={e => setIsValidWednesday(prevState => !prevState)}/>
                                                                            <label className="custom-control-label ml-3" htmlFor="enable-wednesday-switch"></label>
                                                                            <p className="m-0 ml-3 mt-1">{isValidWednesday ? <>Yes</> : <>No</>}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row mb-3">
                                                                        <div className="col-md-4 col-12 ">
                                                                            <p className="font-weight-semi-bold  mt-1 mb-1">Thursday</p>
                                                                        </div>
                                                                        <div className="col-md-8 col-12 custom-control custom-switch">
                                                                            <input className="custom-control-input" type="checkbox" id="enable-thursday-switch" checked={isValidThursday}
                                                                                   onChange={e => setIsValidThursday(prevState => !prevState)}/>
                                                                            <label className="custom-control-label ml-3" htmlFor="enable-thursday-switch"></label>
                                                                            <p className="m-0 ml-3 mt-1">{isValidThursday ? <>Yes</> : <>No</>}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row mb-3">
                                                                        <div className="col-md-4 col-12 ">
                                                                            <p className="font-weight-semi-bold  mt-1 mb-1">Friday</p>
                                                                        </div>
                                                                        <div className="col-md-8 col-12 custom-control custom-switch">
                                                                            <input className="custom-control-input" type="checkbox" id="enable-friday-switch" checked={isValidFriday}
                                                                                   onChange={e => setIsValidFriday(prevState => !prevState)}/>
                                                                            <label className="custom-control-label ml-3" htmlFor="enable-friday-switch"></label>
                                                                            <p className="m-0 ml-3 mt-1">{isValidFriday ? <>Yes</> : <>No</>}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row mb-3">
                                                                        <div className="col-md-4 col-12 ">
                                                                            <p className="font-weight-semi-bold  mt-1 mb-1">Saturday</p>
                                                                        </div>
                                                                        <div className="col-md-8 col-12 custom-control custom-switch">
                                                                            <input className="custom-control-input" type="checkbox" id="enable-saturday-switch" checked={isValidSaturday}
                                                                                   onChange={e => setIsValidSaturday(prevState => !prevState)}/>
                                                                            <label className="custom-control-label ml-3" htmlFor="enable-saturday-switch"></label>
                                                                            <p className="m-0 ml-3 mt-1">{isValidSaturday ? <>Yes</> : <>No</>}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row mb-3">
                                                                        <div className="col-md-4 col-12 ">
                                                                            <p className="font-weight-semi-bold  mt-1 mb-1">Sunday</p>
                                                                        </div>
                                                                        <div className="col-md-8 col-12 custom-control custom-switch">
                                                                            <input className="custom-control-input" type="checkbox" id="enable-sunday-switch" checked={isValidSunday}
                                                                                   onChange={e => setIsValidSunday(prevState => !prevState)}/>
                                                                            <label className="custom-control-label ml-3" htmlFor="enable-sunday-switch"></label>
                                                                            <p className="m-0 ml-3 mt-1">{isValidSunday ? <>Yes</> : <>No</>}</p>
                                                                        </div>
                                                                    </div>
                                                                </>}
                                                            </div>
                                                            <div className="row mt-3">
                                                                <div className="col-md-4 col-12 ">
                                                                    <p className="text-left font-weight-semi-bold  mt-1 mb-1">Valid only at specific times of the day</p>
                                                                </div>
                                                                <div className="col-md-8 col-12 custom-control custom-switch">
                                                                    <input className="custom-control-input" type="checkbox" id="valid-specific-times-toggle" checked={validOnlyAtSpecificTimes} onChange={e => {
                                                                        setValidOnlyAtSpecificTimes(!validOnlyAtSpecificTimes)
                                                                        if ( !e.target.checked ) {
                                                                            setValidOnlyAtSpecificTimes(false)
                                                                            setEnabledFromTime("00:00:00")
                                                                            setEnabledToTime("23:59:59")
                                                                        }
                                                                    }}/>
                                                                    <label className="custom-control-label ml-3" htmlFor="valid-specific-times-toggle"></label>
                                                                    <p className="text-left m-0 ml-3 mt-1">{validOnlyAtSpecificTimes ? <>Yes</> : <>No</>}</p>
                                                                </div>
                                                            </div>
                                                            {validOnlyAtSpecificTimes && <div className="row mb-3">
                                                                <div className="col-md-4 col-12 ">
                                                                    <p className="font-weight-semi-bold  mt-1 mb-1">Time Range</p>
                                                                </div>
                                                                <div className="col-md-7 col-12">
                                                                    <TimeRangeSlider
                                                                        startTime={enabledFromTime}
                                                                        endTime={enabledToTime}
                                                                        onChange={value => {
                                                                            setEnabledFromTime(value.startTime)
                                                                            setEnabledToTime(value.endTime)
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>}
                                                        </>}
                                                        
                                                            <div className="row mt-3 mb-1">
                                                                <div className="col-md-4 col-12 ">
                                                                    <p className="font-weight-semi-bold mb-1">Maximum Stay</p>
                                                                </div>
                                                                <div className="col-md-8 col-12 d-flex align-items-center">
                                                                    <MinutesInputWithUnit
                                                                        numberOfMinutes={ maxStayMinutes }
                                                                        handleChange={ setMaxStayMinutes }
                                                                    />
                                                                    <button type="button" className="btn btn-sm btn-falcon-default d-flex align-items-center m-0 ml-2" onClick={ () => setMaxStayMinutes(null) }>
                                                                        <i className="fas fa-undo mr-1"></i>
                                                                        Clear
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        

                                                        
                                                            <div className="row mb-3">
                                                                <div className="col-md-4 col-12 ">
                                                                    <p className="font-weight-semi-bold mb-1">No return within</p>
                                                                </div>
                                                                <div className="col-md-8 col-12 d-flex align-items-center">
                                                                    <MinutesInputWithUnit
                                                                        numberOfMinutes={ noReturnWithinMinutes }
                                                                        handleChange={ setNoReturnWithinMinutes }
                                                                    />
                                                                    <button type="button" className="btn btn-sm btn-falcon-default d-flex align-items-center m-0 ml-2" onClick={ () => setNoReturnWithinMinutes(null) }>
                                                                        <i className="fas fa-undo mr-1"></i>
                                                                        Clear
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        
                                                    </div>
                                                    <hr className="border-dashed border-bottom-0"></hr>
                                                    <div className="row">
                                                        <div className="col-md-4 col-12 ">
                                                            <p className="font-weight-semi-bold mt-1 mb-1">Notes</p>
                                                        </div>
                                                        <div className="col-md-8 col-12">
                                                            <div className="form-group mb-1">
                                                                <textarea className="form-control mb-0" rows={3} value={reason} onChange={(e) => setReason(e.target.value)}/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="modal-footer">
                                                    <button type="button" className="btn btn-danger btn-sm ml-2" data-dismiss="modal" onClick={() => {
                                                        setAllowListClientId("");
                                                        setAnprCameraId(null)
                                                        setAllowListItemSiteGroup("");
                                                        setRoi("");
                                                        setTabActiveKey("site");
                                                    }}>Cancel
                                                    </button>
                                                    <button type="button" className="btn btn-success btn-sm ml-2" disabled={!canAddAllowList} data-dismiss="modal" onClick={() => addToSiteAllowList()}>
                                                        Confirm
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {<div className="details-container collapse" aria-labelledby="Site Allow List" data-parent="#site-allowed-vrms" id="site-allow-list">
                                        {showAllowListFilterPills && allowListAppliedFilters && <div className="px-3 py-2 border-top d-flex align-items-center flex-wrap">
                                            {Object.entries(allowListAppliedFilters).map(([label,value]) => !StringHelpers.isNullOrEmpty(value) && <div className="mr-2" key={label}>
                                                <AppliedFilterDisplay
                                                    label={label}
                                                    onTextClick={() => setShowAllowListFiltersModal(true)}
                                                    onCloseClick={closedLabel => {
                                                        clearAllowListFilterByLabel(closedLabel)
                                                        setAllowListAppliedFilters(prevState => {
                                                            const updatedFilters = { ...prevState }
                                                            if ( closedLabel === "From" || closedLabel === "To" || closedLabel === "Date Range" ) {
                                                                updatedFilters.From = null
                                                                updatedFilters.To = null
                                                                updatedFilters["Date Range"] = null
                                                            } else {
                                                                updatedFilters[closedLabel] = null
                                                            }
                                                            const hasRemainingFilters = Object.values(updatedFilters).some(value => !StringHelpers.isNullOrEmpty(value))
                                                            return hasRemainingFilters ? updatedFilters : null
                                                        })
                                                    }}
                                                    value={value}
                                                />
                                            </div>)}
                                            {allowListAppliedFilters && Object.keys(allowListAppliedFilters).length > 0 && <button type="button" className="btn btn-none p-0 m-0 fs--1 nowrap" onClick={() => clearAllowListFilters()}>Clear all filters</button>}
                                        </div>}
                                        <div className="card-body bg-light border-top p-0">
                                            <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer allow-list-table">
                                                <thead className="bg-200 text-900">
                                                <tr>
                                                    <th>
                                                        <ColumnSortTrigger
                                                            onClick={direction => handleSortTriggerClick(0,direction)}
                                                            currentSortBy={currentSortBy}
                                                            sortBy={0}
                                                            localStorageKey={`${props.user.id}-allowListSortPreference`}
                                                            label="VRM"
                                                        />
                                                    </th>
                                                    <th>&nbsp;</th>
                                                    <th>Driver Name</th>
                                                    <th>Vehicle</th>
                                                    <th>Site(s)</th>
                                                    <th>Site Group</th>
                                                    <th>
                                                        <ColumnSortTrigger
                                                            onClick={direction => handleSortTriggerClick(1,direction)}
                                                            currentSortBy={currentSortBy}
                                                            sortBy={1}
                                                            localStorageKey={`${props.user.id}-allowListSortPreference`}
                                                            label="Start Date"
                                                        />
                                                    </th>
                                                    <th>End Date</th>
                                                    <th>Validity</th>
                                                    <th className='text-center'>Enabled</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {isLoading ? <tr>
                                                    <td colSpan={8}><Loader/></td>
                                                </tr> : <>
                                                    {allowListData && !arrayUtilities.isNullOrEmpty(allowListData.items) && allowListData.items.map((item) => {
                                                        var url = "/organisation/" + props.organisationId + "/allowed-vrm/" + item.id;
                                                        return (<tr key={item.id} className='fs--2'>
                                                            <td><Link to={url} className="number-plate-link"><h6 className="mb-0 compact-number-plate">{item.vrm}</h6></Link></td>
                                                            <td className="text-center">{
                                                                !StringHelpers.isNullOrEmpty(item.blueBadgeNumber) && <img width="20px" src='/assets/img/illustrations/wheelchair-symbol.svg' />
                                                            }</td>
                                                            <td>{ item.driverName }</td>
                                                            <td>
                                                                <div className='allow-list-clamped-cell'>{item.vehicleMake} {item.vehicleModel}</div>
                                                            </td>
                                                            <td>
                                                                {!StringHelpers.isNullOrEmpty(item.siteName) ? <>{item.siteName}</> : !StringHelpers.isNullOrEmpty(item.clientName) ? <>{item.clientName}</> : <>All</>}
                                                            </td>
                                                            <td>{item.siteGroupName && <>{item.siteGroupName}</>}</td>
                                                            <td>
                                                                {!StringHelpers.isNullOrEmpty(item.startDate) ? <>{toDateTimeString(item.startDate)} </> : <span>&mdash; </span>}
                                                            </td>
                                                            <td>
                                                                {!StringHelpers.isNullOrEmpty(item.endDate) ? <> {toDateTimeString(item.endDate)} <span className='text-end'>{isDateTimeElapsed(item.endDate) &&
                                                                    <i class="fas fa-exclamation-triangle text-warning ml-2 fs-1"></i>}</span></> : <span>&mdash; </span>}
                                                            </td>
                                                            <td>{renderValidity(item)}</td>
                                                            <td className='text-center'>{item.isEnabled ? <i className="fas fa-check text-success"></i> : <i className="fas fa-times text-danger"></i>}</td>
                                                        </tr>)
                                                    })}
                                                </>}
                                                </tbody>
                                            </table>
                                        </div>
                                        {!isLoading && <div className="card-footer border-top ">
                                            <div className="d-flex justify-content-center row align-items-center">
                                                <div className="col-auto align-items-center">
                                                    <Pagination totalResults={allowListData?.totalCount} currentPage={pageNumber} changePageNumber={changePageNumber}/>
                                                </div>
                                            </div>
                                        </div>}
                                    </div>}
                                    {showAllowListFiltersModal && <AllowListFiltersModal
                                        showModal={showAllowListFiltersModal}
                                        handleClose={() => setShowAllowListFiltersModal(false)}
                                        handleConfirm={(draftFilters) => {
                                            setFilterStart(draftFilters.filterStart)
                                            setFilterEnd(draftFilters.filterEnd)
                                            setFilterPeriodType(draftFilters.filterPeriodType)
                                            setCreatedByUserId(draftFilters.createdByUserId)
                                            setCreatedBySource(draftFilters.createdBySource)
                                            setAllowListAppliedFilters(draftFilters.appliedFilters)
                                            setShowAllowListFilterPills(true)
                                            setShowAllowListFiltersModal(false)
                                            setPageNumber(0)
                                            const sortPreference = StringHelpers.sortPreference(`${props.user.id}-allowListSortPreference`);
                                            getAllowList(search, draftFilters.filterStart, draftFilters.filterEnd, 0, draftFilters.filterPeriodType, sortPreference.sortBy, sortPreference.sortDirection, draftFilters.createdByUserId, draftFilters.createdBySource)
                                        }}
                                        initialFilterStart={filterStart}
                                        initialFilterEnd={filterEnd}
                                        initialFilterPeriodType={filterPeriodType}
                                        initialCreatedByUserId={createdByUserId}
                                        initialCreatedBySource={createdBySource}
                                        initialAppliedFilters={allowListAppliedFilters}
                                        createdByOptions={createdByOptions}
                                        key="site-allow-list-filters-modal"
                                    />}
                                </div>
                                {
                                    showCamerasFiltersModal &&
                                    <CamerasFiltersModal
                                        showModal={ showCamerasFiltersModal }
                                        handleClose={ () => setShowCamerasFiltersModal(false) }
                                        handleConfirm={ (draftFilters) => {
                                            setCameraFilterStatus(draftFilters.cameraFilterStatus)
                                            setCamerasAppliedFilters(draftFilters.appliedFilters)
                                            setShowCamerasFilterPills(true)
                                            setShowCamerasFiltersModal(false)
                                        } }
                                        initialCameraFilterStatus={ cameraFilterStatus }
                                        initialAppliedFilters={ camerasAppliedFilters }
                                        key="cameras-filters-modal"
                                    />
                                }
                                {
                                    showPayDisplayFiltersModal &&
                                    <PayDisplayMachinesFiltersModal
                                        showModal={ showPayDisplayFiltersModal }
                                        handleClose={ () => setShowPayDisplayFiltersModal(false) }
                                        handleConfirm={ (draftFilters) => {
                                            setPayDisplayFilterStatus(draftFilters.payDisplayFilterStatus)
                                            setPayDisplayAppliedFilters(draftFilters.appliedFilters)
                                            setShowPayDisplayFilterPills(true)
                                            setShowPayDisplayFiltersModal(false)
                                        } }
                                        initialPayDisplayFilterStatus={ payDisplayFilterStatus }
                                        initialAppliedFilters={ payDisplayAppliedFilters }
                                        key="pay-and-display-machines-filters-modal"
                                    />
                                }

                                <ConfigurationUpdate
                                    id="site-group"
                                    dataTarget="site-group-table"
                                    title="Groups"
                                    ariaLabel="Site Group Table"
                                    headerButtonText="Add"
                                    handleHeaderAction={() => history.push(`/organisation/${props.organisationId}/client/${clientId}/site/${siteId}/groups`)}
                                    isActionAllowed={!isThirdPartyUser && !roleUtilities.isOrganisationProcessor(props.user,props.organisationId)}
                                >
                                    <table className="table table-sm mb-0 table-striped fs--1 border-bottom border-200 no-footer ">
                                        <thead className="bg-200 text-900">
                                        <tr>
                                            <th>Name</th>
                                            <th>Maximum Concurrent Sessions</th>
                                            <th>Maximum Number of Allow List Entries</th>
                                            <th>Notes</th>
                                            <th>&nbsp;</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {!arrayUtilities.isNullOrEmpty(siteGroups) && siteGroups.map(group => {
                                            return (<tr key={group.id}>
                                                <td><h6 className="mb-0">{group.name}</h6></td>
                                                <td>{group.maximumConcurrentParkingSessions}</td>
                                                <td>{group.maximumNumberOfAllowListEntries}</td>
                                                <td>{group.notes}</td>
                                                {!isThirdPartyUser && !roleUtilities.isOrganisationProcessor(props.user,props.organisationId) && <td className='text-right'>
                                                    <button onClick={() => history.push(`/organisation/${props.organisationId}/client/${clientId}/site/${siteId}/groups/${group.id}`)} className='btn p-0'><i
                                                        className="fas fa-edit mr-2"></i></button>
                                                    <button onClick={() => setSiteGroupId(group.id)} data-toggle="modal" data-target="#delete-site-group-modal" className='btn p-0'><i className="fas fa-trash-alt"></i></button>
                                                </td>}
                                            </tr>)
                                        })}
                                        </tbody>
                                    </table>
                                </ConfigurationUpdate>
                                {siteGroupId && <div className="modal fade" id="delete-site-group-modal" tabIndex="-1" role="dialog" aria-labelledby="delete-site-group-modal-Label" aria-hidden="true">
                                    <div className="modal-dialog" role="document">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h5 className="modal-title" id="delete-site-group-modal-Label">Are you sure you want to delete this site group?</h5>
                                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>
                                            <div className="modal-footer">
                                                <button onClick={() => setSiteGroupId(null)} type="button" className="btn btn-falcon-default btn-sm ml-2" data-dismiss="modal">Cancel</button>
                                                <button
                                                    type="button"
                                                    className="btn btn-danger btn-sm ml-2"
                                                    data-dismiss="modal"
                                                    onClick={() => {
                                                        Api.deleteSiteGroup(props.organisationId,siteId,siteGroupId,() => {
                                                            setSiteGroupId(null);
                                                            getSiteGroups();
                                                        },error => console.log(error),props.token)
                                                    }}
                                                >
                                                    Delete
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>}

                                <div className="card mb-3">
                                    <div className="card-header">
                                        <div className="row align-items-center justify-content-between">
                                            <div className="col-2">
                                                <h5 className="mb-0">
                                                    <button className="button-no-style button-card-header collapsed" id="attachment" type="button" data-toggle="collapse" data-target="#attachment-details" aria-expanded="true"
                                                            aria-controls="site-details">
                                                        Attachments <i className="fas fa-chevron-down"></i>
                                                    </button>
                                                </h5>
                                            </div>
                                            {!isThirdPartyUser && !roleUtilities.isOrganisationProcessor(props.user,props.organisationId) && <div className="col-auto">
                                                <button className="btn btn-falcon-default my-0" data-toggle="modal" data-target="#add-new-evidence">Add Attachment</button>
                                            </div>}
                                        </div>
                                    </div>
                                    <div className="modal fade save-dialog success-dialog" id="add-new-evidence" tabIndex="-1" role="dialog">
                                        <div className="modal-dialog" role="document">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <h4 className="modal-title">Add Attachments from my device</h4>
                                                </div>
                                                <div className="modal-body">
                                                    <div className="upload-files-wrapper row mb-3">
                                                        <div className='col-md-3 col-12'>
                                                            <p className="font-weight-semi-bold mb-1 px-1">Files</p>
                                                        </div>
                                                        <div className="col-md-9">
                                                            <button className="btn btn-falcon-default w-100 mb-1" onClick={selectFiles}>Select file from my device</button>
                                                            <input type="file" id="upload-files-select" name="upload-files-select" onChange={e => onSelectFiles(e)} style={{ display:'none' }}/>
                                                            {!arrayUtilities.isNullOrEmpty(attachmentUploads) && <div className="files-wrapper">
                                                                {attachmentUploads.map((upload) => <div className='mb-1'>
                                                                    <div className='d-flex align-items-center'>
                                                                        <p className="mb-0 nowrap w-auto">{upload.file.name}</p>
                                                                        {attachmentUploadError && <div className="text-danger">
                                                                            <i className="fas fa-times mx-1"></i> Upload failed.</div>}
                                                                        <div className="ml-1">
                                                                            {attachmentUploadComplete && !attachmentUploadError && <i className="fas fa-check text-success mx-1"></i>}
                                                                        </div>
                                                                    </div>
                                                                    {!attachmentUploadError && !attachmentUploadComplete && <div className="col-12">
                                                                        <div className="w-100 px-1">
                                                                            <div className="progress">
                                                                                <div className="progress-bar" role="progressbar" aria-valuenow={attachmentUploadProgress} aria-valuemin="0" aria-valuemax="100"
                                                                                     style={{ "width":attachmentUploadProgress + "%" }}/>
                                                                            </div>
                                                                        </div>
                                                                    </div>}
                                                                </div>)}
                                                            </div>}
                                                        </div>

                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-3 col-12 ">
                                                            <p className="font-weight-semi-bold mb-1 px-1">Valid from</p>
                                                        </div>
                                                        <div className="col-md-9 col-12">
                                                            <div className="form-group mb-0">
                                                                <input className="form-control mb-1" type="datetime-local" value={toInputFieldDateTimeString(attachmentValidFrom)} onChange={(e) => setAttachmentValidFrom(e.target.value)}/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-3 col-12 ">
                                                            <p className="font-weight-semi-bold mb-1 px-1">Valid to</p>
                                                        </div>
                                                        <div className="col-md-9 col-12">
                                                            <div className="form-group mb-0">
                                                                <input className="form-control mb-1" type="datetime-local" value={toInputFieldDateTimeString(attachmentValidTo)} onChange={(e) => setAttachmentValidTo(e.target.value)}/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="modal-footer">
                                                    <div>
                                                        <button onClick={() => {
                                                            setAttachmentFileIds([])
                                                            setAttachmentUploads([])
                                                            setAttachmentUploadComplete(false)
                                                            setAttachmentUploadError(false)
                                                            setAttachmentUploadProgress(1)
                                                        }} type="button" className="btn btn-falcon-default mr-2" data-dismiss="modal">Cancel
                                                        </button>
                                                        <button disabled={arrayUtilities.isNullOrEmpty(attachmentFileIds)} type="button" className="btn btn-primary" data-dismiss="modal" onClick={() => addAttachments()}>Save</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body bg-light border-top details-container collapse" id="attachment-details" aria-labelledby="Attachments" data-parent="#attachment">
                                        {attachments && <div className="d-flex flex-column site-attachments">
                                            <div className='d-flex justify-content-between align-items-center'>
                                                <ul className="nav nav-tabs w-100" id="attachmentsTabbed" role="tablist">
                                                    <li className="nav-item" role="presentation">
                                                        <button className={`nav-link ${attachmentsDefaultTab === "images" ? "active" : ""}`} id="images-tab" data-toggle="tab" data-target="#images" type="button" role="tab"
                                                                aria-controls="images" aria-selected={attachmentsDefaultTab === "images"}><i className='far fa-file-image mr-2'></i>
                                                            Images
                                                            <span
                                                                className={`ml-2 badge badge-${attachments.filter(attachment => attachment.isImage).length === 0 ? "secondary" : "success"}`}>{attachments.filter(attachment => attachment.isImage).length}</span>
                                                        </button>
                                                    </li>
                                                    <li className="nav-item" role="presentation">
                                                        <button className={`nav-link ${attachmentsDefaultTab === "files" ? "active" : ""}`} id="files-tab" data-toggle="tab" data-target="#files" type="button" role="tab" aria-controls="files"
                                                                aria-selected={attachmentsDefaultTab === "files"}><i className='far fa-list-alt mr-2'></i>
                                                            Documents
                                                            <span
                                                                className={`ml-2 badge badge-${attachments.filter(attachment => !attachment.isImage).length === 0 ? "secondary" : "success"}`}>{attachments.filter(attachment => !attachment.isImage).length}</span>
                                                        </button>
                                                    </li>
                                                </ul>
                                                <div class="btn-group">
                                                    <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" data-display="static" aria-haspopup="true" aria-expanded="false">
                                                        {attachmentsLayout === "grid" ? <><i className='fas fa-border-all mr-2'></i>
                                                            Grid</> : <><i className='far fa-list-alt mr-2'></i>
                                                            List</>}
                                                    </button>
                                                    <div class="dropdown-menu p-0">
                                                        <button onClick={() => {
                                                            setAttachmentsLayout("grid");
                                                            localStorage.setItem(attachmentsLayoutKey,"grid");
                                                        }} class="dropdown-item p-2 w-fit">
                                                            <i className='fas fa-border-all mr-2'></i>
                                                            Grid
                                                        </button>
                                                        <button onClick={() => {
                                                            setAttachmentsLayout("list");
                                                            localStorage.setItem(attachmentsLayoutKey,"list");
                                                        }} class="dropdown-item p-2 w-fit">
                                                            <i className='far fa-list-alt mr-2'></i>
                                                            List
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="tab-content" id="attachmentsTabbedContent">
                                                <div className={`tab-pane fade p-2 bg-white ${attachmentsDefaultTab === "images" ? "show active" : ""}`} id="images" role="tabpanel" aria-labelledby="images-tab">
                                                    <AttachmentsDisplay
                                                        attachments={attachments}
                                                        type="images"
                                                        viewLayout={attachmentsLayout}
                                                        onDeleteClick={(id) => setDeleteAttachmentId(id)}
                                                        onEditClick={(attachment) => {
                                                            setAttachmentValidFrom(attachment.validFrom)
                                                            setAttachmentValidTo(attachment.validTo)
                                                            setEditableAttachment(attachment)
                                                        }}
                                                        canUpdate={roleUtilities.isOrganisationAdmin(props.user,props.organisationId)}
                                                    />
                                                </div>
                                                <div className={`tab-pane fade p-2 bg-white ${attachmentsDefaultTab === "files" ? "show active" : ""}`} id="files" role="tabpanel" aria-labelledby="files-tab">
                                                    <AttachmentsDisplay
                                                        attachments={attachments}
                                                        type="documents"
                                                        viewLayout={attachmentsLayout}
                                                        onDeleteClick={(id) => setDeleteAttachmentId(id)}
                                                        onEditClick={(attachment) => {
                                                            setAttachmentValidFrom(attachment.validFrom)
                                                            setAttachmentValidTo(attachment.validTo)
                                                            setEditableAttachment(attachment)
                                                        }}
                                                        canUpdate={roleUtilities.isOrganisationAdmin(props.user,props.organisationId)}
                                                    />
                                                </div>
                                            </div>
                                            {!StringHelpers.isNullOrEmpty(deleteAttachmentId) && <Modal show onHide={() => setDeleteAttachmentId(null)}>
                                                <Modal.Header>
                                                    <Modal.Title className="d-flex gap-2 align-items-center text-danger"><h5>Are you sure you want to delete this attachment?</h5></Modal.Title>
                                                    <button type="button" className="close" onClick={() => setDeleteAttachmentId(null)} aria-label="Close">
                                                        <span aria-hidden="true">&times;</span>
                                                    </button>
                                                </Modal.Header>
                                                <Modal.Footer>
                                                    <button onClick={() => setDeleteAttachmentId(null)} type="button" className="btn btn-falcon-default btn-sm ml-2" data-dismiss="modal">Cancel</button>
                                                    <button type="button" className="btn btn-danger btn-sm ml-2" onClick={() => deleteAttachment()}>Delete</button>
                                                </Modal.Footer>
                                            </Modal>}
                                            {editableAttachment && !arrayUtilities.isNullOrEmpty(attachments) && <Modal show onHide={() => setEditableAttachment(null)}>
                                                <Modal.Header>
                                                    <Modal.Title className="d-flex align-items-center">Edit attachment</Modal.Title>
                                                    <button type="button" className="close" onClick={() => {
                                                        setEditableAttachment(null)
                                                        setAttachmentValidFrom(null)
                                                        setAttachmentValidTo(null)
                                                    }} aria-label="Close">
                                                        <span aria-hidden="true">&times;</span>
                                                    </button>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <div className="row mb-3">
                                                        <div className="col-md-3 col-12">
                                                            <p className="font-weight-semi-bold mb-1 px-1">File</p>
                                                        </div>
                                                        <div className="col-md-9 col-12">
                                                            <p className='m-0'>{editableAttachment.filename}</p>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-3 col-12">
                                                            <p className="font-weight-semi-bold mb-1 px-1 mt-1">Valid from</p>
                                                        </div>
                                                        <div className="col-md-9 col-12">
                                                            <div className="form-group mb-0">
                                                                <input className="form-control mb-1" type="datetime-local" value={toInputFieldDateTimeString(attachmentValidFrom)} onChange={(e) => setAttachmentValidFrom(e.target.value)}/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-3 col-12 ">
                                                            <p className="font-weight-semi-bold mb-1 px-1 mt-1">Valid to</p>
                                                        </div>
                                                        <div className="col-md-9 col-12">
                                                            <div className="form-group mb-0">
                                                                <input className="form-control mb-1" type="datetime-local" value={toInputFieldDateTimeString(attachmentValidTo)} onChange={(e) => setAttachmentValidTo(e.target.value)}/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Modal.Body>
                                                <Modal.Footer>
                                                    <button onClick={() => {
                                                        setEditableAttachment(null)
                                                        setAttachmentValidFrom(null)
                                                        setAttachmentValidTo(null)
                                                    }} type="button" className="btn btn-falcon-default btn-sm ml-2">Cancel
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn btn-primary btn-sm ml-2"
                                                        onClick={() => editAttachment()}
                                                    >
                                                        Save
                                                    </button>
                                                </Modal.Footer>
                                            </Modal>}
                                            {!StringHelpers.isNullOrEmpty(attachmentUpdateError) && <ErrorModal
                                                message={attachmentUpdateError}
                                                onHide={() => setAttachmentUpdateError(null)}
                                            />}
                                        </div>}
                                    </div>
                                </div>

                                <div className="card mb-3">
                                    <div className="card-header">
                                        <div className="row align-items-center justify-content-between">
                                            <div className="col-2">
                                                <h5 className="mb-0">
                                                    <button className="button-no-style button-card-header collapsed" id="note-button" type="button" data-toggle="collapse" data-target="#notes" aria-expanded="true"
                                                            aria-controls="site-details">
                                                        Notes <i className="fas fa-chevron-down"></i>
                                                    </button>
                                                </h5>
                                            </div>
                                            {!isThirdPartyUser && !roleUtilities.isOrganisationProcessor(props.user,props.organisationId) && <div className="col-2 text-right pl-0 filter-buttons-wrapper">
                                                <button className="btn btn-success btn-sm ml-1" data-toggle="modal" data-target="#note-modal"><i className="fas fa-plus"></i> Add</button>
                                            </div>}
                                        </div>
                                    </div>
                                    <div className="modal fade" id="note-modal" tabIndex="-1" role="dialog" aria-labelledby="On Hold Modal" aria-hidden="true">
                                        <div className="modal-dialog" role="document">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <h5 className="modal-title" id="deleteModalLabel">Add a note to this site.</h5>
                                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                        <span aria-hidden="true">&times;</span>
                                                    </button>
                                                </div>
                                                <div className="modal-body">
                                                    <div className="row">
                                                        <div className="col-12 ">
                                                            <p className="font-weight-semi-bold  mt-1 mb-2">Note:</p>
                                                        </div>
                                                        <div className="col-12">
                                                            <div className="form-group mb-0">
                                                                <textarea className="form-control mb-0" rows={4} value={note} onChange={(e) => setNote(e.target.value)}/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="modal-footer">
                                                    <button type="button" className="btn btn-falcon-default btn-sm ml-2" data-dismiss="modal">Cancel</button>
                                                    <button type="button" className="btn btn-success btn-sm ml-2" data-dismiss="modal" onClick={() => addNote()}>
                                                        Confirm
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body bg-light border-top details-container collapse" id="notes" aria-labelledby="Allow List" data-parent="#note-button">
                                        <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer ">
                                            <thead className="bg-200 text-900">
                                            <tr>
                                                <th>Origin</th>
                                                <th>Note</th>
                                                <th className="text-center">Date</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {notes !== null && notes.map((item) => {
                                                return (<>
                                                    <tr key={item.id} className="align-items-center">
                                                        <td>{item.note !== null && <h6 className="pt-1">
                                                            {item.userName}
                                                        </h6>}
                                                        </td>
                                                        <td>{item.note}</td>
                                                        <td className="text-center">{toDateTimeString(item.timestamp)}</td>
                                                    </tr>
                                                </>)
                                            })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div className="modal fade" id="deleteModal" tabIndex="-1" role="dialog" aria-labelledby="deleteModalLabel" aria-hidden="true">
                                    <div className="modal-dialog" role="document">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h5 className="modal-title" id="deleteModalLabel">Are you sure you want to delete this site?</h5>
                                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>
                                            <div className="modal-footer">
                                                <button type="button" className="btn btn-falcon-default btn-sm ml-2" data-dismiss="modal">Cancel</button>
                                                <button type="button" className="btn btn-danger btn-sm ml-2" data-dismiss="modal" onClick={() => Api.deleteSite(() => history.push(clientUrl),props.organisationId,siteId,props.token)}>
                                                    Delete
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}
            {!StringHelpers.isNullOrEmpty(allowListError) && <ErrorModal
                message={allowListError}
                onHide={() => setAllowListError(null)}
            />}
        </>)
}

export default Site;